<template>
    <div>
      <div style="padding-top: 55px" />

      <!-- Loading Overlay -->
      <div v-if="isQueryLoading" class="loading-overlay">
        <div class="loading-spinner">
          <i class="fa fa-spinner fa-spin fa-3x"></i>
          <p class="mt-3">데이터 조회 중...</p>
        </div>
      </div>

      <div
        class="bg-light"
        :style="{ 'margin-left': sidebar.width + 'px' }"
      >
  
          
  <!--
          
        <nav class="nav border-bottom shadow-sm" style="background-color: #4b5162">
          <a class="btn tab" @click="tab = 'images'" :style="{'color': tab == 'images' ? 'white' : 'darkgray'}">
            <i class="fa fa-picture-o" aria-hidden="true"></i> Images
          </a>
          <a class="btn tab" @click="tab = 'exports'" :style="{'color': tab == 'exports' ? 'white' : 'darkgray'}">
            <i class="fa fa-share" aria-hidden="true"></i> Exports
          </a>
          <a class="btn tab" @click="tab = 'members'" :style="{'color': tab == 'members' ? 'white' : 'darkgray'}">
            <i class="fa fa-users" aria-hidden="true"></i> Members
          </a>
          <a class="btn tab" @click="tab = 'statistics'" :style="{'color': tab == 'statistics' ? 'white' : 'darkgray'}">
            <i class="fa fa-bar-chart" aria-hidden="true"></i> Statistics
          </a>
          <a class="btn tab" @click="tab = 'settings'" :style="{'color': tab == 'settings' ? 'white' : 'darkgray'}">
            <i class="fa fa-cog" aria-hidden="true"></i> Settings
          </a>
        </nav>
  
  -->
          
        <div class="bg-light text-left" style="overflow: auto; height: calc(100vh - 100px); margin: 10px">
          <div class="container-fluid" v-show="tab == 'images'">

            <p class="text-center" v-if="images.length < 1">
              조건에 맞는 이미지가 없습니다. 검색 조건을 변경하거나 이미지를 업로드 해주세요.
            </p>
            <div v-else>
              <div class="d-flex justify-content-between align-items-center">
                <Pagination :pages="pages" @pagechange="updatePage" />
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="onBatchDownloadPDFs"
                  :disabled="batchDownloading"
                >
                  <span v-if="batchDownloading">
                    <i class="fa fa-spinner fa-spin"></i> 다운로드 중...
                  </span>
                  <span v-else>
                    <i class="fa fa-download"></i> 결과지 일괄 다운로드
                  </span>
                </button>
              </div>
              <p class="query-summary">
                <strong>조회 기간: {{ query.studyDate__gte || '-' }} ~ {{ query.studyDate__lte || '-' }} / 총 {{ imageCount }}건</strong>
              </p>
              <div class="row">
                <!-- <b-table striped hover :items="images"></b-table> -->
                <b-table striped hover :items="images" :fields="images.fields" class="dataset-table" thead-class="table-header-nowrap">
                  
                  <template #cell(view_image)="data">
                    <!-- `data.value` is the value after formatted by the Formatter -->
                    <button 
                    type="button"
                    class="btn btn-secondary btn-block"
                    @click="openAnnotator(data.value)"
                    >
                      View
                    </button>
                  </template>
                  
                  <template #cell(process_ai)="data">
                    <button 
                    type="button"
                    class="btn btn-secondary btn-block"
                    @click="onProcessAIClick(data.value)">Process</button>
                  </template>

                  <template #cell(referral)="data">
                    <button 
                    type="button"
                    class="btn btn-secondary btn-block"
                    @click="onProcessAIClick(data.value)">분석</button>
                  </template>

                  <template #cell(dicomMeta)="row">
                    <b-button @click="row.toggleDetails">Show
                    </b-button>
                  </template>

                  <template #row-details="row">
                    <b-card>{{row.item.dicomMeta}}</b-card>
                  </template>

                  <template #cell(options)="data">
                    <b-dropdown 
                      variant="outline-secondary"
                      text="..."
                      :id="'dropdownImage' + data.value"
                    >
                      <button 
                        class="btn dropdown-item"
                        @click="openAnnotator(data.value)"
                      >
                        뷰어
                      </button>
                      <button
                        class="btn dropdown-item"
                        @click="onDownloadPDF(data.value)"
                      >
                        결과지 다운로드
                      </button>
                      <button
                        class="btn dropdown-item"
                        @click="onDownloadClick(data.value, false)"
                      >
                        안저 이미지 다운로드
                      </button>
                      <button
                        class="btn dropdown-item"
                        @click="onDownloadClick(data.value, true)"
                      >
                        DCM 다운로드
                      </button>
                      <button
                        class="btn dropdown-item"
                        @click="onDeleteClick(data.value)"
                      >
                        이미지 삭제
                      </button>
                      <button
                        class="btn dropdown-item"
                        @click="exportCSV"
                      >
                        Export CSV
                      </button>
                    </b-dropdown>
                  </template>

                </b-table>
                <!-- <ImageCard v-for="image in images" :key="image.id" :image="image" /> -->
              </div>
              <Pagination :pages="pages" @pagechange="updatePage" />
            </div>
  
          </div>
          <!-- <div class="container" v-show="tab == 'exports'">
            <div class="card my-3 p-3 shadow-sm mr-2">
              <h6 class="border-bottom border-gray pb-2"><b>Exports</b></h6>
              
              <div 
                class="media text-muted pt-3" 
                v-for="exp in datasetExports"
                :key="exp.id"
              >
                <div class="media-body lh-125 border-bottom border-gray">
                    {{exp.id}}. Exported {{ exp.ago.length > 0 ? exp.ago : 0 + " seconds" }} ago
                    <div style="display: inline">
                      <span
                        v-for="tag in exp.tags"
                        class="badge badge-secondary"
                        style="margin: 1px"
                        :key="tag.id"
                      >
                        {{tag}}
                      </span>
                    </div>
                    <button 
                      class="btn btn-sm btn-success"
                      style="float: right; margin: 2px; padding: 2px"
                      @click="downloadExport(exp.id)"
                    >
                      Download
                    </button>
                </div>
              </div>
            </div>
          </div>
  
          <div class="container" v-show="tab == 'members'">
  
            <div class="card my-3 p-3 shadow-sm mr-2">
              <h6 class="border-bottom border-gray pb-2"><b>Invite Members</b></h6>
              
            </div>
            
            <div class="card my-3 p-3 shadow-sm mr-2">
              <h6 class="border-bottom border-gray pb-2"><b>Existing Members</b></h6>
              
              <div class="media text-muted pt-3" v-for="user in users" :key="user.name">
                <img :src="require(`@/assets/user.png`)" class="mr-2 rounded" style="width: 32px; height: 32px;">
                <div class="media-body pb-3 mb-0 small lh-125 border-bottom border-gray">
                  <div class="d-flex justify-content-between align-items-center w-100">
                    <div class="text-gray-dark">
                      <strong>{{ user.name }}</strong> @{{user.username}}
                    </div>
                    <a href="#">{{ user.group }}</a>
                  </div>
                  <span class="d-block">Last seen: {{ new Date(user.last_seen['$date']).toISOString().slice(0, 19).replace('T', ' ') }} UTC</span>
                </div>
              </div>
            </div>
  
          </div>
          <div class="container" v-show="tab == 'statistics'">
            <div v-if="stats == null">
              Crunching numbers...
            </div>
  
            <div v-else>
              <div class="row">
                
                <div v-if="stats.total" class="card my-3 p-3 shadow-sm col-3 mr-2">
                  <h6 class="border-bottom border-gray pb-2"><b>Total</b></h6>
                  <div class="row" v-for="stat in Object.keys(stats.total)" :key="stat">
                    <strong class="col-8">{{stat}}:</strong>
                    <span class="col-4">{{stats.total[stat].toFixed(0)}}</span>
                  </div>
                </div>
  
                <div v-if="stats.average" class="card my-3 p-3 shadow-sm col-4 mr-2">
                  <h6 class="border-bottom border-gray pb-2"><b>Average</b></h6>
                  <div class="row" v-for="stat in Object.keys(stats.average)" :key="stat">
                    <strong class="col-8">{{stat}}:</strong>
                    <span class="col-4">{{stats.average[stat].toFixed(0)}}</span>
                  </div>
                </div>
  
                <div v-if="stats.categories" class="card my-3 p-3 shadow-sm col-4 mr-2">
                  <h6 class="border-bottom border-gray pb-2"><b>Annotations Per Category</b></h6>
                  <div class="row" v-for="stat in Object.keys(stats.categories)" :key="stat">
                    <strong class="col-8">{{stat}}:</strong>
                    <span class="col-4">{{stats.categories[stat].toFixed(0)}}</span>
                  </div>
                </div>
  
                <div v-if="stats.images_per_category" class="card my-3 p-3 shadow-sm col-4 mr-2">
                  <h6 class="border-bottom border-gray pb-2"><b>Annotated Images Per Category</b></h6>
                  <div class="row" v-for="stat in Object.keys(stats.images_per_category)" :key="stat">
                    <strong class="col-8">{{stat}}:</strong>
                    <span class="col-4">{{stats.images_per_category[stat].toFixed(0)}}</span>
                  </div>
                </div>
  
              </div>
              
            </div>
          </div>
          <div class="container" v-show="tab == 'settings'">
            <div class="card my-3 p-3 shadow-sm mr-2">
              <h6 class="border-bottom border-gray pb-2"><b>Metadata</b></h6>
              
              <button 
                class="btn btn-sm btn-block btn-danger"
                @click="resetMetadata"
              >
                Rest All Metadata
              </button>
            </div>
          </div> -->
  
        </div>
      </div>
  
      <div
        id="filter"
        ref="sidebar"
        class="sidebar"
        :style="{ width: sidebar.width + 'px' }"
      >
        <div style="padding-top: 10px" />
        <h3>
          {{ institutionName }}
          <span
            v-if="dataset && dataset.exam_type"
            class="badge ml-2"
            :class="dataset.exam_type === 'screening' ? 'badge-primary' : 'badge-warning'"
          >
            {{ dataset.exam_type === 'screening' ? '검진' : '비급여' }}
          </span>
        </h3>

        <div style="height: 20px"></div>

        <!-- ⓪ 파일 업로드 -->
        <p class="sidebar-guide-text">⓪ 수동 업로드가 필요할 경우 아래 버튼을 이용해주세요.</p>
        <div class="sidebar-section-buttons">
          <button
            type="button"
            class="btn btn-secondary btn-block"
            @click="importModal"
            id="upload_button"
          >
            <div v-if="importing.id != null" class="progress">
              <div
                class="progress-bar bg-secondary"
                :style="{ 'width': `${importing.progress}%` }"
              >
                업로드 중
              </div>
            </div>
            <div v-else>파일 업로드</div>
          </button>
        </div>

        <div style="height: 30px"></div>

        <!-- ① 기본 범위 버튼 -->
        <p class="sidebar-guide-text">① 조회할 범위를 선택해주세요.</p>
        <div class="date-range-buttons">
          <button type="button" class="btn btn-secondary" @click="setDateRangeToday">오늘</button>
          <button type="button" class="btn btn-secondary" @click="setDateRangeThisWeek">이번 주</button>
          <button type="button" class="btn btn-secondary" @click="setDateRangeThisMonth">이번 달</button>
        </div>

        <div style="height: 30px"></div>

        <!-- ② 달력 -->
        <p class="sidebar-guide-text">② 특정 날짜나 범위를 설정하려면 달력을 이용해주세요.</p>
        <div class="sidebar-calendar-section">
          <flat-pickr
            v-model="inlineDateRange"
            :config="inlineDateConfig"
            @on-change="onInlineDateChange"
          />
        </div>

        <!-- 조회 버튼 -->
        <div class="sidebar-section-buttons">
          <button
            type="button"
            class="btn btn-secondary btn-block btn-sm-custom"
            @click="updatePage()"
          >조회</button>
        </div>

        <div style="height: 30px"></div>

        <!-- ③ 고급검색 -->
        <p class="sidebar-guide-text">③ 이름, 환자번호로 검색 시 아래 버튼을 이용해 주세요.</p>
        <div class="sidebar-section-buttons">
          <button
            type="button"
            class="btn btn-secondary btn-block btn-sm-custom"
            data-toggle="modal"
            data-target="#advancedSearchModal"
          >고급검색</button>
        </div>

        <div style="height: 30px"></div>

        <!-- ④ 전체 분석 -->
        <p class="sidebar-guide-text">④ 우측 목록 전체를 분석하려면 아래 버튼을 이용해 주세요.(이미 분석 결과가 있는 건은 다시 분석되지 않습니다)</p>
        <div class="sidebar-section-buttons">
          <button
            type="button"
            class="btn btn-success btn-block"
            @click="createAllReferralTask(dataset.id)"
            id="predictAll_button"
          >
            <div v-if="aiprocessing.id != null" class="progress">
              <div
                class="progress-bar bg-success"
                :style="{ 'width': `${aiprocessing.progress}%` }"
              >
                처리 중
              </div>
            </div>
            <div v-else>전체 분석</div>
          </button>
        </div>

        <!-- 환경 설정 (최하단) -->
        <div class="sidebar-settings-bottom">
          <!-- Admin 전용: PACS/EMR 설정 (좌하단) -->
          <button
            v-if="$store.getters['user/isAdmin']"
            type="button"
            class="btn btn-link admin-settings-icon-btn"
            @click="settingsModal"
            id="admin_settings_button"
            title="관리자 설정 (PACS/EMR)"
          >
            <i class="fa fa-wrench fa-lg"></i>
          </button>

          <!-- 모든 사용자: 계정 설정 (우하단) -->
          <button
            type="button"
            class="btn btn-link settings-icon-btn ml-auto"
            @click="userSettingsModal"
            id="user_settings_button"
            title="사용자 설정"
          >
            <i class="fa fa-cog fa-lg"></i>
          </button>
        </div>
      </div>
  
      <!-- <div class="modal fade" tabindex="-1" role="dialog" id="generateDataset">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Generate a Dataset</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>Keyword</label>
                  <input class="form-control" v-model="keyword" />
                </div>
                <div class="form-group">
                  <label>Limit</label>
                  <input
                    class="form-control"
                    type="number"
                    v-model="generateLimit"
                  />
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary"
                @click="generateDataset"
              >
                Generate
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div> -->

      <!-- 고급검색 모달 -->
      <div class="modal fade" tabindex="-1" role="dialog" id="advancedSearchModal">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">고급검색</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>이름</label>
                <input
                  v-model="query.patientName__icontains"
                  class="form-control"
                  placeholder="환자명 검색"
                />
              </div>
              <div class="form-group">
                <label>환자번호</label>
                <input
                  v-model="query.patientID__icontains"
                  class="form-control"
                  placeholder="환자번호 검색"
                />
              </div>
              <div class="form-group">
                <label>날짜</label>
                <flat-pickr
                  v-model="modalDateRange"
                  :config="modalDateConfig"
                  class="form-control"
                  placeholder="날짜 범위 선택"
                  @on-change="onModalDateChange"
                />
              </div>
              <div class="form-group">
                <label>분석상태</label>
                <select v-model="stateEMR" class="form-control">
                  <option v-for="(label, key) in stateEMRTypes" :key="key" :value="key">
                    {{ label }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>표시 개수</label>
                <select v-model="limit" class="form-control">
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
                @click="updatePage()"
              >
                검색
              </button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                닫기
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" tabindex="-1" role="dialog" id="imgUpload">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">파일 업로드</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <!-- DICOM 모드 -->
              <div v-if="uploadMode === 'dicom'">
                <div
                  class="drop-zone"
                  :class="{ 'drag-over': isDragging }"
                  @dragover.prevent
                  @dragenter.prevent="onDragEnter"
                  @dragleave.prevent="onDragLeave"
                  @drop.prevent="onDrop"
                  @click="triggerFileInput"
                >
                  <div v-if="isDragging" class="drop-zone-overlay">
                    <i class="fa fa-cloud-upload fa-3x"></i>
                    <p>여기에 파일을 놓으세요</p>
                  </div>
                  <div v-else class="drop-zone-content">
                    <i class="fa fa-cloud-upload fa-2x"></i>
                    <p>클릭하거나 파일을 드래그하여 업로드</p>
                    <p class="drop-zone-hint">(DICOM 파일만 지원)</p>
                  </div>
                  <input
                    type="file"
                    ref="fileInput"
                    class="hidden-file-input"
                    id="imagetoupload"
                    multiple
                    @change="onFileSelect"
                  />
                </div>
                <!-- 선택된 파일 목록 -->
                <div v-if="selectedFiles.length > 0" class="selected-files">
                  <p class="selected-files-header"><strong>선택된 파일 ({{ selectedFiles.length }}개)</strong></p>
                  <ul class="selected-files-list">
                    <li v-for="(file, index) in selectedFiles" :key="index">
                      <i class="fa fa-file-o"></i> {{ file.name }}
                      <span class="file-size">({{ formatFileSize(file.size) }})</span>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- JPG/PNG 모드 -->
              <div v-else>
                <!-- 파일 선택 -->
                <div class="form-group">
                  <label class="small font-weight-bold">이미지 파일</label>
                  <input
                    type="file"
                    class="form-control-file"
                    accept=".jpg,.jpeg,.png"
                    @change="jpegFile = $event.target.files[0]"
                  />
                  <small v-if="jpegFile" class="text-muted">
                    {{ jpegFile.name }} ({{ formatFileSize(jpegFile.size) }})
                  </small>
                </div>

                <hr>

                <!-- 환자 정보 폼 -->
                <h6 class="mb-3">환자 정보</h6>
                <div class="form-group">
                  <label class="small">이름 <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="jpegForm.name"
                    placeholder="환자 이름"
                  />
                </div>
                <div class="form-row">
                  <div class="form-group col-6">
                    <label class="small">나이 <span class="text-danger">*</span></label>
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      v-model.number="jpegForm.age"
                      placeholder="나이"
                      min="1"
                      max="150"
                    />
                  </div>
                  <div class="form-group col-6">
                    <label class="small">성별 <span class="text-danger">*</span></label>
                    <select class="form-control form-control-sm" v-model="jpegForm.sex">
                      <option value="" disabled>선택</option>
                      <option value="M">남</option>
                      <option value="F">여</option>
                    </select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-6">
                    <label class="small">처방일</label>
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      v-model="jpegForm.studyDate"
                    />
                    <small class="form-text text-muted">미입력 시 오늘 날짜</small>
                  </div>
                  <div class="form-group col-6">
                    <label class="small">환자번호</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="jpegForm.patientId"
                      placeholder="(선택)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer d-flex justify-content-between">
              <div>
                <button
                  v-if="uploadMode === 'dicom'"
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  @click="uploadMode = 'jpeg'"
                >
                  <i class="fa fa-image"></i> JPG/PNG 업로드
                </button>
                <button
                  v-else
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  @click="uploadMode = 'dicom'"
                >
                  <i class="fa fa-file"></i> DICOM 업로드
                </button>
              </div>
              <div>
                <button
                  v-if="uploadMode === 'dicom'"
                  type="button"
                  class="btn btn-primary"
                  @click="submit"
                  data-dismiss="modal"
                >
                  업로드
                </button>
                <button
                  v-else
                  type="button"
                  class="btn btn-primary"
                  :disabled="jpegUploading"
                  @click="submitJpeg()"
                >
                  {{ jpegUploading ? '업로드 중...' : '업로드' }}
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  닫기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" tabindex="-1" role="dialog" id="settings" data-backdrop="static">
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Settings</h5>
              <button
                type="button"
                class="close"
                @click="closeSettingsModal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <!-- EMR Column -->
                <div class="col-md-6">
                  <div class="card h-100">
                    <div class="card-header bg-secondary text-white">
                      <h5 class="mb-0">EMR</h5>
                    </div>
                    <div class="card-body">
                      <div class="row mb-3">
                        <div class="col-6">
                          <label class="small">Use EMR</label>
                          <select v-model="settings.EMR.REQUIRE" class="form-control form-control-sm">
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                          </select>
                        </div>
                        <div class="col-6">
                          <label class="small">Type</label>
                          <select v-model="settings.EMR.TYPE" class="form-control form-control-sm" @change="onEmrTypeChange">
                            <option
                              v-for="t in integrationConfig.emr.types"
                              :key="t.value"
                              :value="t.value"
                            >{{ t.label }}</option>
                          </select>
                        </div>
                      </div>

                      <label class="small">Configuration (JSON)</label>
                      <textarea
                        v-model="emrConfigJson"
                        class="form-control code-editor"
                        rows="12"
                        placeholder='{"ENDPOINT": "...", "EXAM_CODE": "..."}'
                        :class="{'is-invalid': emrConfigError}"
                      ></textarea>
                      <div v-if="emrConfigError" class="invalid-feedback d-block">
                        {{ emrConfigError }}
                      </div>

                      <div class="mt-3">
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm"
                          @click="validateEmrConfig"
                        >
                          <i class="fa fa-check"></i> Validate
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-info btn-sm ml-2"
                          @click="loadEmrDefaultConfig"
                        >
                          <i class="fa fa-refresh"></i> Load Default
                        </button>
                        <span v-if="emrValidateResult" class="ml-2" :class="emrValidateResult.success ? 'text-success' : 'text-danger'">
                          <i :class="emrValidateResult.success ? 'fa fa-check-circle' : 'fa fa-times-circle'"></i>
                          {{ emrValidateResult.message }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- PACS Column -->
                <div class="col-md-6">
                  <div class="card h-100">
                    <div class="card-header bg-primary text-white">
                      <h5 class="mb-0">PACS</h5>
                    </div>
                    <div class="card-body">
                      <div class="row mb-3">
                        <div class="col-3">
                          <label class="small">Use PACS (READ)</label>
                          <select v-model="settings.PACS.REQUIRE" class="form-control form-control-sm">
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                          </select>
                        </div>
                        <div class="col-3">
                          <label class="small">Use PACS (WRITE)</label>
                          <select v-model="settings.PACS.REQUIRESEND" class="form-control form-control-sm">
                            <option value="false">No</option>
                            <option value="true">Yes</option>
                          </select>
                        </div>
                        <div class="col-3">
                          <label class="small">Type</label>
                          <select v-model="settings.PACS.TYPE" class="form-control form-control-sm" @change="onPacsTypeChange">
                            <option
                              v-for="t in integrationConfig.pacs.types"
                              :key="t.value"
                              :value="t.value"
                            >{{ t.label }}</option>
                          </select>
                        </div>
                        <div class="col-3">
                          <label class="small">Report Format</label>
                          <select v-model="settings.PACS.REPORT_TYPE" class="form-control form-control-sm">
                            <option value="pdf">PDF</option>
                            <option value="image">Image (JPEG)</option>
                          </select>
                        </div>
                      </div>

                      <label class="small">Configuration (JSON)</label>
                      <textarea
                        v-model="pacsConfigJson"
                        class="form-control code-editor"
                        rows="12"
                        placeholder='{"IP": "...", "PORT": 104, "AETITLE": "..."}'
                        :class="{'is-invalid': pacsConfigError}"
                      ></textarea>
                      <div v-if="pacsConfigError" class="invalid-feedback d-block">
                        {{ pacsConfigError }}
                      </div>

                      <div class="mt-3">
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm"
                          @click="validatePacsConfig"
                        >
                          <i class="fa fa-check"></i> Validate
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-info btn-sm ml-2"
                          @click="loadPacsDefaultConfig"
                        >
                          <i class="fa fa-refresh"></i> Load Default
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-success btn-sm ml-2"
                          :disabled="pacsTestLoading"
                          @click="testPacsConnection"
                        >
                          <i :class="pacsTestLoading ? 'fa fa-spinner fa-spin' : 'fa fa-plug'"></i>
                          Test
                        </button>
                        <span v-if="pacsTestResult" class="ml-2" :class="pacsTestResult.success ? 'text-success' : 'text-danger'">
                          <i :class="pacsTestResult.success ? 'fa fa-check-circle' : 'fa fa-times-circle'"></i>
                          {{ pacsTestResult.message }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary"
                @click="saveSettings"
              >
                Save
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                @click="closeSettingsModal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 사용자 설정 모달 -->
      <div class="modal fade" tabindex="-1" role="dialog" id="userSettings">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">사용자 설정</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label><strong>결과지 다운로드 설정</strong></label>

                <!-- 다운로드 형식 -->
                <div class="mt-3">
                  <label class="small text-muted">다운로드 형식</label>
                  <select v-model="downloadSettings.format" class="form-control form-control-sm">
                    <option value="pdf">PDF</option>
                    <option value="jpg">JPG</option>
                  </select>
                </div>

                <!-- 품질 -->
                <div class="mt-3">
                  <label class="small text-muted">품질</label>
                  <select v-model="downloadSettings.quality" class="form-control form-control-sm">
                    <option value="high">고품질 인쇄용 (300 DPI)</option>
                    <option value="standard">일반용 (150 DPI)</option>
                    <option value="low">저용량 (100 DPI)</option>
                  </select>
                </div>

                <!-- 결과지 유형 -->
                <div class="mt-3">
                  <label class="small text-muted">결과지 유형</label>
                  <select v-model="downloadSettings.page_mode" class="form-control form-control-sm">
                    <option value="full">전체 결과지 (4페이지)</option>
                    <option value="simple">간단 결과지 (1페이지)</option>
                  </select>
                </div>

                <!-- 예상 용량 표시 -->
                <div class="mt-3 p-2 bg-light rounded">
                  <small>
                    <strong>예상 용량:</strong>
                    <span class="text-primary ml-1">{{ estimatedSize }}</span>
                  </small>
                </div>
              </div>

              <hr>

              <div class="form-group mb-0">
                <label><strong>업로드 설정</strong></label>
                <div class="mt-3">
                  <label class="small text-muted">기본 업로드 모드</label>
                  <select v-model="settings.upload_mode" class="form-control form-control-sm">
                    <option value="dicom">DICOM</option>
                    <option value="jpeg">JPG/PNG</option>
                  </select>
                  <small class="form-text text-muted">
                    업로드 모달의 기본 모드를 설정합니다. 모달 내에서 전환도 가능합니다.
                  </small>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="saveDownloadSettings"
                data-dismiss="modal"
              >
                저장
              </button>
              <button
                type="button"
                class="btn btn-secondary btn-sm"
                data-dismiss="modal"
              >
                닫기
              </button>
            </div>
          </div>
        </div>
      </div>

  
      <div class="modal fade" tabindex="-1" role="dialog" id="exportDataset">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Export {{institutionName}}</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>Categories (Empty export all)</label>
                  <TagsInput
                    v-model="exporting.categories"
                    element-id="exportCategories"
                    :typeahead="false"
                  ></TagsInput>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary"
                @click="exportCOCO"
              >
                Export
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  // import axios from "axios";
  import axios from '@/libs/axios'
  import toastrs from "@/mixins/toastrs";
  import Dataset from "@/models/datasets";
  import Export from "@/models/exports";
//   import ImageCard from "@/components/cards/ImageCard";
  import Pagination from "@/components/Pagination";
  // import PanelString from "@/components/PanelInputString"; // 고급검색 모달에서 일반 input 사용
  // import PanelDateRange from "@/components/PanelDateRange"; // 고급검색 모달에서 일반 flatpickr 사용
  // import PanelToggle from "@/components/PanelToggle";
  // import PanelDropdown from "@/components/PanelInputDropdown" // 고급검색 모달에서 일반 select 사용
  import JQuery from "jquery";
  import TagsInput from "@/components/TagsInput";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import { Korean } from "flatpickr/dist/l10n/ko.js";
  import {
    STARTED,
    PROCESSING,
    FINISHED,
    FINISHED_TRANSMIT,
    FINISHED_PACS,
    FINISHED_PACS_FAILED,
    FAILED,
    TERMINAL_FINISHED,
    TERMINAL_PREDICTION_STATUSES,
    ACTIVE_PREDICTION_STATUSES,
  } from '@/libs/predictionStatus';

  import {  } from 'bootstrap-vue';
  import { mapMutations } from "vuex";
  // import { set } from "vue/types/umd";
  
  // import InferenceButton from "@/components/annotator/tools/InferenceButton";

  let $ = JQuery;
  
  export default {
    name: "TabularDataset",
    components: {
    //   ImageCard,
      Pagination,
      // PanelString, // 고급검색 모달에서 일반 input 사용
      // PanelDropdown, // 고급검색 모달에서 일반 select 사용
      // PanelDateRange, // 고급검색 모달에서 일반 flatpickr 사용
      TagsInput,
      flatPickr,
      // InferenceButton,
    },
    mixins: [toastrs],
    props: {
      identifier: {
        type: [Number, String],
        required: true
      }
    },
    data() {
      // const currentDate = new Date();
      // Format the date as YYYY-MM-DD
      // const formattedDate = currentDate.toISOString().split('T')[0];
      const formattedDate = new Date().toLocaleDateString('en-CA'); //en-CA locale formatting is yyyy-MM-dd
      // console.log(formattedDate)
      return {
        pages: 1,
        generateLimit: 100,
        limit: 100,
        imageCount: 0,
        categories: [],
        images: [],
        timage: 'test image',
        folders: [],
        dataset: {
          id: 0
        },
        users: [],
        subdirectories: [],
        status: {
          data: { state: true, message: "Loading data" }
        },
        keyword: "",
        mouseDown: false,
        sidebar: {
          drag: false,
          width: window.innerWidth * 0.2,
          canResize: false
        },
        generate: {
          progress: 0,
          id: null
        },
        aiprocessing: {
          progress: 0,
          id: null
        },
        // 비동기 PACS 다운로드/분석 작업 추적
        analysisJobs: {},  // { jobId: { patientName, status } }
        analysisPollingInterval: null,
        importing: {
          progress: 0,
          id: null,
          timeout: null
        },
        exporting: {
          categories: [],
          progress: 0,
          id: null
        },
        selected: {
          categories: []
        },
        datasetExports: [],
        tab: "images",
        ascending: 'ascending',
        ascendingTypes:{
          ascending: '▲',
          descending: '▼'
        },
        order: "id",
        orderTypes: {
          patientName: "Patient Name",
          patientID: "Patient ID",
          studyDateTime: "Study Date",
        },
        stateEMR: "Unselected",
        stateEMRTypes: {
          Unselected: "-",
          Unreferred: "미분석",
          Referred: "분석",
          Finished: "분석완료",
          FinishedTransmit: "분석/전송완료"
        },
        query: {
          file_name__icontains: "",
          patientName__icontains: "",
          patientID__icontains: "",
          studyDate__gte: formattedDate,
          studyDate__lte: formattedDate,
          ...this.$route.query
        },
        panel: {
          showAnnotated: true,
          showNotAnnotated: true
        },
        stats: null,
        batchDownloading: false,
        batchDownloadPollInterval: null,  // 폴링 interval ID (cleanup용)
        inferencePollingTimer: null,
        pendingInferenceImageIds: {},
        inferencePollingStartedAt: null,
        downloadSettings: {
          format: 'pdf',
          quality: 'standard',
          page_mode: 'full'
        },
        downloadSettingsLoading: false,
        isQueryLoading: false,
        // 고급검색 모달 표시 여부
        showAdvancedSearch: false,
        // 달력 동기화 플래그 (무한 루프 방지)
        isSyncingDate: false,
        // 인라인 달력 설정
        inlineDateRange: [formattedDate, formattedDate],
        inlineDateConfig: {
          mode: "range",
          dateFormat: "Y-m-d",
          inline: true,
          locale: Korean
        },
        // 모달 달력 설정
        modalDateRange: [formattedDate, formattedDate],
        modalDateConfig: {
          mode: "range",
          dateFormat: "Y-m-d",
          locale: Korean
        },
        settings:{
          PACS: {
            REQUIRE: "false",
            TYPE: "none",
            AETITLE: "XAIMED_DEV_PACS",
            IP: "orthanc",
            PORT: "4242",
            MODALITY: "XC",
            FORCELOSSLESSTRANFERPROTOCOL: false,
            REQUIRESEND: "false",
            REPORT_TYPE: "pdf"
          },
          EMR: {
            TYPE: "none",
            REQUIRE: "false",
            REQUIRESEND: "false"
          },
        },
        pacsTestLoading: false,
        pacsTestResult: null,
        // New settings UI state
        emrConfigJson: '{}',
        pacsConfigJson: '{}',
        emrConfigError: null,
        pacsConfigError: null,
        emrValidateResult: null,
        // Integration config loaded from API (types + defaults)
        integrationConfig: {
          emr: { types: [{ value: 'none', label: 'None' }], defaults: {} },
          pacs: { types: [{ value: 'none', label: 'None' }], defaults: {} }
        },
        // Settings modal backup (for cancel/restore)
        settingsBackup: null,
        emrConfigJsonBackup: '{}',
        pacsConfigJsonBackup: '{}',
        // 파일 업로드 드래그앤드롭
        isDragging: false,
        dragCounter: 0,
        selectedFiles: [],
        // JPG/PNG 업로드 모드
        uploadMode: 'dicom',
        jpegForm: { name: '', age: null, sex: '', studyDate: '', patientId: '' },
        jpegFile: null,
        jpegUploading: false
      };
    },
    methods: {
      ...mapMutations(["addProcess", "removeProcess"]),
      // 다운로드 설정 관련
      loadDownloadSettings() {
        var self = this;
        if (!this.dataset || !this.dataset.id) return;

        this.downloadSettingsLoading = true;
        axios.get('/api/report-settings/' + this.dataset.id)
          .then(function(response) {
            self.downloadSettings.format = response.data.format || 'pdf';
            self.downloadSettings.quality = response.data.quality || 'standard';
            self.downloadSettings.page_mode = response.data.page_mode || 'full';
          })
          .catch(function() {
            // 설정이 없으면 기본값 사용
            self.downloadSettings.format = 'pdf';
            self.downloadSettings.quality = 'standard';
            self.downloadSettings.page_mode = 'full';
          })
          .finally(function() {
            self.downloadSettingsLoading = false;
          });
      },
      saveDownloadSettings() {
        var self = this;
        if (!this.dataset || !this.dataset.id) return;

        this.downloadSettingsLoading = true;

        // Upload mode도 dataset settings에 저장
        Dataset.saveSettings(this.dataset.id, this.settings);

        axios.put('/api/report-settings/' + this.dataset.id, {
          format: this.downloadSettings.format,
          quality: this.downloadSettings.quality,
          page_mode: this.downloadSettings.page_mode
        })
          .then(function() {
            self.$toast.success('다운로드 설정이 저장되었습니다.');
          })
          .catch(function(error) {
            var message = (error.response && error.response.data && error.response.data.message)
              ? error.response.data.message
              : '설정 저장에 실패했습니다.';
            self.$toast.error(message);
          })
          .finally(function() {
            self.downloadSettingsLoading = false;
          });
      },
      // 파일 업로드 드래그앤드롭 관련
      onDragEnter() {
        this.dragCounter++;
        this.isDragging = true;
      },
      onDragLeave() {
        this.dragCounter--;
        if (this.dragCounter === 0) {
          this.isDragging = false;
        }
      },
      onDrop(event) {
        this.isDragging = false;
        this.dragCounter = 0;
        var files = event.dataTransfer.files;
        if (files.length > 0) {
          this.selectedFiles = Array.from(files);
        }
      },
      triggerFileInput() {
        this.$refs.fileInput.click();
      },
      onFileSelect(event) {
        var files = event.target.files;
        if (files.length > 0) {
          this.selectedFiles = Array.from(files);
        }
      },
      formatFileSize(bytes) {
        if (bytes === 0) return '0 Bytes';
        var k = 1024;
        var sizes = ['Bytes', 'KB', 'MB', 'GB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
      },
      getPredictionStatusDisplay(status) {
        var statusMap = {
          [STARTED]: '분석시작',
          [PROCESSING]: '분석 중',
          [FINISHED]: '완료',
          [FINISHED_TRANSMIT]: '완료',
          [FINISHED_PACS]: '완료',
          [FINISHED_PACS_FAILED]: '완료(전송실패)',
          [FAILED]: '분석 실패'
        };
        return statusMap[status] || status || '-';
      },

      // Helper function to build metadata with source indicator
      buildMetadata(image, source) {
        const metaField = source === 'emr' ? 'emrMeta' : 'pacsMeta';
        return Object.assign({}, image[metaField] || {}, { metadata_source: source });
      },

      // generateDataset() {
      //   if (this.keyword.length === 0) return;

      //   Dataset.generate(this.dataset.id, {
      //     keywords: [this.keyword],
      //     limit: this.generateLimit
      //   });
      // },
      updatePage(page) {
        let process = "Loading images from dataset";
        this.addProcess(process);
        this.isQueryLoading = true;
        this._fetchDatasetData(page)
          .catch(error => {
            this.axiosReqestError("Loading Dataset", error);
          })
          .finally(() => {
            this.removeProcess(process);
            this.isQueryLoading = false;
          });
      },
      // Silent refresh: no loading spinner, just update data (for polling)
      updatePageSilently() {
        return this._fetchDatasetData(this.page, { resumeInferencePolling: false }).catch(function() {
          // Silent fail - 폴링 중 에러는 무시
        });
      },
      // Shared data fetching logic
      _fetchDatasetData(page, options = {}) {
        return Dataset.getData(this.dataset.id, {
          page: page,
          limit: this.limit,
          // folder: this.folders.join("/"),
          ...this.query,
          // annotated: this.queryAnnotated,
          // category_ids__in: encodeURI(this.selected.categories),
          order: this.order,
          stateEMR: this.stateEMR,
          ascending: this.ascending,
        })
          .then(response => {
            let data = response.data;
            this.settings = {...this.settings,...data.dataset.settings};
            // Initialize JSON editors with settings
            this.initSettingsJson();

            // Save filter state after successful update
            this.saveFilterState();

            // this.images contain data for each entry in the dataset
            // this.images.fields are the columns to show in the table
            // use in conjunction with templates in the template section
            // console.log(data)
            this.images = data.images;
            this.images.forEach(
              image => {
                let i = {...image}
                image.view_image = i
                image.process_ai = i
                image.options = i
                image.referral = i
                // console.log(image)
                if (image.dicomMeta){
                  // image.dateTime = image.dicomMeta['00080020']['Value'][0] + ' ' + image.dicomMeta['00080030']['Value'][0].slice(0,6)
                  try {image.studyDate = image.dicomMeta['00080020']['Value'][0]} catch {console.log('00080020 not found in dicomMeta')}
                  try {image.patientSex = image.dicomMeta['00100040']['Value'][0]} catch {console.log('00100040 not found in dicomMeta')}
                  try {image.patientAge = image.dicomMeta['00101010']['Value'][0]} catch {console.log('00101010 not found in dicomMeta')}
                  try {
                    if ('00200062' in image.dicomMeta) {image.laterality = image.dicomMeta['00200062']['Value'][0]}
                    else if ('00200020' in image.dicomMeta) {image.laterality = image.dicomMeta['00200020']['Value'][0]}
                    else {image.laterality = 'N/A'}
                  } catch {console.log('Laterality not found in dicomMeta')}
                }
                if (image.metadata) {
                  try { image.orderID = image.metadata['ORD_SEQ'] } catch {console.log('orderID (ORD_SEQ) not found in metadata')}
                }
                // prediction_status 한글 매핑
                image.prediction_status_display = this.getPredictionStatusDisplay(image.prediction_status);
              }
            )
            this.images.fields = [
              {label:'처방현황', key:'stateEMR',sortable:true,},
              {label:'처방일', key:'studyDate',sortable:true,},
              {label:'처방번호', key:'orderID',sortable:true,},
              {label:'촬영일', key:'studyDate_image',sortable:true,},
              {label:'환자번호',key:'patientID',sortable:true,},
              {label:'이름',key:'patientName',sortable:true,},
              {label:'성별',key:'patientSex',sortable:true,},
              {label:'나이',key:'patientAge',sortable:true,},
              // {label:'L/R', key:'laterality',sortable:false},
              {label:'AI분석 상태', key:'prediction_status_display',sortable:true,},
              {label:'분석', key:'referral',sortable:false,},
              // {label:'View Image', key:'view_image',sortable:false,},
              // {key:'dicomMeta',label:'Metadata',sortable:false},
              {key:'options',label:'...',sortable:false,}
            ]

            if (options.resumeInferencePolling !== false) {
              this.resumeInferencePollingForActiveImages();
            }

            this.dataset = data.dataset;
            this.categories = data.categories;

            this.imageCount = data.total;
            this.pages = data.pages;
            this.page = data.page;
            this.limit = data.per_page;

            // this.subdirectories = data.subdirectories;
            // this.generate.id = data.generateId;
            // 업로드 중('notnull')에는 서버의 importId를 무시 (프로그레스바 유지)
            if (this.importing.id !== 'notnull') {
              this.importing.id = data.importId;
            }
            // this.exporting.id = data.exportId;
          });
      },
      updateStartDate(startDate) {
        this.query.studyDate__gte = startDate;
        // this.updatePage();
      },
      updateEndDate(endDate) {
        this.query.studyDate__lte = endDate;
        // this.updatePage();
      },
      onInlineDateChange(selectedDates) {
        // 동기화 중이면 무시 (무한 루프 방지)
        if (this.isSyncingDate) return;
        // 인라인 달력에서 날짜 범위 선택 시
        if (selectedDates.length === 2) {
          var start = this.formatLocalDate(selectedDates[0]);
          var end = this.formatLocalDate(selectedDates[1]);
          this.query.studyDate__gte = start;
          this.query.studyDate__lte = end;
          // 모달 달력도 동기화 (플래그 설정)
          this.isSyncingDate = true;
          this.modalDateRange = [start, end];
          this.$nextTick(function() { this.isSyncingDate = false; }.bind(this));
        }
      },
      onModalDateChange(selectedDates) {
        // 동기화 중이면 무시 (무한 루프 방지)
        if (this.isSyncingDate) return;
        // 모달 달력에서 날짜 범위 선택 시
        if (selectedDates.length === 2) {
          var start = this.formatLocalDate(selectedDates[0]);
          var end = this.formatLocalDate(selectedDates[1]);
          this.query.studyDate__gte = start;
          this.query.studyDate__lte = end;
          // 인라인 달력도 동기화 (플래그 설정)
          this.isSyncingDate = true;
          this.inlineDateRange = [start, end];
          this.$nextTick(function() { this.isSyncingDate = false; }.bind(this));
        }
      },
      formatLocalDate(date) {
        // 로컬 시간대 기준으로 YYYY-MM-DD 포맷 반환
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        return year + '-' + month + '-' + day;
      },
      setDateRangeToday() {
        var today = new Date();
        var dateStr = this.formatLocalDate(today);
        this.setDateRange(dateStr, dateStr);
      },
      setDateRangeThisWeek() {
        var today = new Date();
        var dayOfWeek = today.getDay();
        // 일요일을 주의 시작으로 (일요일=0, 토요일=6)
        var sunday = new Date(today);
        sunday.setDate(today.getDate() - dayOfWeek);
        var saturday = new Date(sunday);
        saturday.setDate(sunday.getDate() + 6);
        var startStr = this.formatLocalDate(sunday);
        var endStr = this.formatLocalDate(saturday);
        this.setDateRange(startStr, endStr);
      },
      setDateRangeThisMonth() {
        var today = new Date();
        var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
        var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        var startStr = this.formatLocalDate(firstDay);
        var endStr = this.formatLocalDate(lastDay);
        this.setDateRange(startStr, endStr);
      },
      setDateRange(start, end) {
        this.query.studyDate__gte = start;
        this.query.studyDate__lte = end;
        this.isSyncingDate = true;
        this.inlineDateRange = [start, end];
        this.modalDateRange = [start, end];
        this.$nextTick(function() {
          this.isSyncingDate = false;
          this.updatePage();
        }.bind(this));
      },
      openAnnotator(image) {
        // Check if image has an ID (exists in MongoDB)
        if (image.id) {
          // Image exists in MongoDB, open annotator
          this.$router.push({
            name: "annotate",
            params: { identifier: image.id }
          });
        } else {
          // Image not in MongoDB yet, need to retrieve first
          this.$toastr.warning("이미지를 먼저 가져와야 합니다. Process 버튼을 클릭해주세요.", "Image not available");
        }
      },
      startPACSRetrieval(image){
        const patientName = image.patientName || image.patient_name;
        let body = {
            patientID: image.patientID || image.patient_id,
            studyDate: image.studyDate || image.study_date,
            dataset_id: image.dataset || this.dataset.id,
            metadata: this.buildMetadata(image, 'pacs')
          }
        axios.post("/api/image/pacsgetdicom", body)
          .then(response => {
            const { job_id, status, message } = response.data;
            this.$toastr.info(message, `${patientName} 이미지 분석 요청됨`);

            // job_id가 있으면 폴링 시작 (비동기 모드)
            if (job_id && status !== 'completed') {
              this.$set(this.analysisJobs, job_id, { patientName, status });
              this.startAnalysisPolling();
            } else if (status === 'completed') {
              this.updatePage();
            }
          })
          .catch(error => {
            const message = (error.response && error.response.data && error.response.data.message) || 'Unknown error';
            this.$toastr.error(message, `${patientName} 이미지 조회 실패`);
          })
      },
      startEMRRetrieval(image){
        const patientName = image.patientName;
        let body = {
            patientID: image.patientID,
            studyDate: image.studyDate,
            dataset_id: image.dataset,
            metadata: this.buildMetadata(image, 'emr')
          }
        axios.post("/api/image/pacsgetdicom", body)
          .then(response => {
            const { job_id, status, message } = response.data;
            this.$toastr.info(message, `${patientName} 이미지 분석 요청됨`);

            // job_id가 있으면 폴링 시작 (비동기 모드)
            if (job_id && status !== 'completed') {
              this.$set(this.analysisJobs, job_id, { patientName, status });
              this.startAnalysisPolling();
            } else if (status === 'completed') {
              this.updatePage();
            }
          })
          .catch(error => {
            const message = (error.response && error.response.data && error.response.data.message) || 'Unknown error';
            this.$toastr.error(message, `${patientName} 이미지 조회 실패`);
          })
      },
      // 비동기 분석 작업 상태 폴링
      startAnalysisPolling() {
        if (this.analysisPollingInterval) return; // 이미 폴링 중

        this.analysisPollingInterval = setInterval(async () => {
          const jobIds = Object.keys(this.analysisJobs);
          if (jobIds.length === 0) {
            clearInterval(this.analysisPollingInterval);
            this.analysisPollingInterval = null;
            return;
          }

          try {
            // 배치 조회 API 호출
            const response = await axios.get(`/api/analysis/jobs?ids=${jobIds.join(',')}`);

            let hasCompleted = false;
            for (const job of response.data.jobs) {
              const jobData = this.analysisJobs[job.id];
              if (!jobData) continue;

              // 완료 또는 실패 시 처리
              if (['completed', 'failed', 'partial'].includes(job.overall_status)) {
                if (job.overall_status === 'completed') {
                  this.$toastr.success(`${jobData.patientName} 분석 완료`, 'PACS 다운로드 완료');
                } else if (job.overall_status === 'failed') {
                  const errorMsg = job.upload_error || job.inference_error || '알 수 없는 오류';
                  this.$toastr.error(errorMsg, `${jobData.patientName} 분석 실패`);
                } else if (job.overall_status === 'partial') {
                  this.$toastr.warning('일부 결과 저장 실패', `${jobData.patientName} 분석 부분 완료`);
                }
                this.$delete(this.analysisJobs, job.id);
                hasCompleted = true;
              } else {
                // 상태 업데이트
                this.analysisJobs[job.id].status = job.overall_status;
              }
            }

            // 모든 job 완료 시 페이지 새로고침
            if (Object.keys(this.analysisJobs).length === 0) {
              clearInterval(this.analysisPollingInterval);
              this.analysisPollingInterval = null;
              this.updatePage();
            } else if (hasCompleted) {
              // 일부 완료 시에도 페이지 새로고침
              this.updatePage();
            }
          } catch (error) {
            console.error('Polling error:', error);
            // 네트워크 에러 시 폴링 계속
          }
        }, 5000); // 5초 간격
      },
      // 컴포넌트 언마운트 시 폴링 정리
      beforeDestroy() {
        if (this.analysisPollingInterval) {
          clearInterval(this.analysisPollingInterval);
          this.analysisPollingInterval = null;
        }
      },
      downloadURI(uri, exportName) {
        let link = document.createElement("a");
        link.href = uri;
        link.download = exportName;
        document.body.appendChild(link);
        link.click();
        link.remove();
      },
      onDeleteClick(image) {
        if (confirm("Are you sure you want to delete this image?")) {
          axios.delete("/api/image/" + image.id).then(() => {
            this.updatePage();
          });
        }
      },
      onDownloadClick(image, asdicom) {
        if (asdicom){
          this.downloadURI(
            "/api/image/" + image.id + "?asAttachment=true&asDicom=true",
            image.file_name
          );
        } else {
          this.downloadURI(
            "/api/image/" + image.id + "?asAttachment=true",
            image.file_name
          );
        }
      },
      onDownloadPDF(image) {
        // Check if image has results
        var currentStatus = image.prediction_status || '';
        if (TERMINAL_FINISHED.indexOf(currentStatus) === -1) {
          this.$toastr.warning("AI 분석이 완료된 이미지만 결과지를 다운로드할 수 있습니다.", "결과지 다운로드");
          return;
        }
        
        // Check if result key results exist
        var rKey = this.resultKey;
        if (!image.results || !image.results[rKey]) {
          this.$toastr.warning("이 이미지에 대한 AI 분석 결과가 없습니다.", "결과지 다운로드");
          return;
        }
        
        const options = {
          progressBar: true,
          positionClass: "toast-bottom-left",
          timeOut: 5000
        };
        
        this.$toastr.info("결과지를 다운로드 중입니다...", "결과지 다운로드", options);
        
        var downloadUrl = "/api/resultAI/download-pdf/" + image.id +
          "?format=" + this.downloadSettings.format +
          "&quality=" + this.downloadSettings.quality +
          "&page_mode=" + this.downloadSettings.page_mode;

        axios.get(downloadUrl, {
          responseType: 'blob'
        })
        .then(response => {
          // Create download link
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          
          // Get filename from Content-Disposition header or use default
          const contentDisposition = response.headers['content-disposition'];
          var ext = this.downloadSettings.format === 'jpg'
            ? (this.downloadSettings.page_mode === 'full' ? '.zip' : '.jpg')
            : '.pdf';
          let filename = (image.patientID || 'Unknown') + '_' + (image.patientName || 'Unknown') + '_' + (image.studyDate || 'Unknown') + '_' + rKey + ext;
          
          if (contentDisposition) {
            // Try RFC 5987 format first: filename*=UTF-8''encoded_filename
            const rfc5987Match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
            if (rfc5987Match) {
              try {
                // Decode the URL-encoded filename
                filename = decodeURIComponent(rfc5987Match[1]);
              } catch (e) {
                console.warn('Failed to decode RFC 5987 filename, using fallback');
              }
            } else {
              // Fallback to standard format: filename="filename" or filename=filename
              const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
              if (filenameMatch) {
                filename = filenameMatch[1];
              }
            }
          }
          
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          
          this.$toastr.success("결과지가 다운로드되었습니다.", "결과지 다운로드 완료", options);
        })
        .catch(error => {
          let errorMessage = "결과지 다운로드 중 오류가 발생했습니다.";
          if (error.response && error.response.data) {
            // Try to parse error message from blob if it's a blob response
            if (error.response.data instanceof Blob) {
              error.response.data.text().then(text => {
                try {
                  const json = JSON.parse(text);
                  errorMessage = json.message || errorMessage;
                } catch (e) {
                  // If not JSON, use default message
                }
              });
            } else if (error.response.data.message) {
              errorMessage = error.response.data.message;
            }
          }
          this.$toastr.error(errorMessage, "결과지 다운로드 실패", options);
        });
      },
      createAllAITask(dataset_id) {
        // External API 사용자 제한 검사
        if (this.shouldBlockWebFeatures) {
          this.$toastr.error(
            "API 계정은 프로덕션 환경에서 웹 Inference를 사용할 수 없습니다. External API를 이용해주세요.",
            "Inference Blocked"
          );
          return;
        }
        let process = "Predicting All Images";
        this.addProcess(process);

        if (this.aiprocessing.id != null){
          return;
        }
        this.aiprocessing.id = 'notnull';
        this.aiprocessing.progress = 80;
        let options = {
          progressBar: true,
          positionClass: "toast-bottom-left",
          timeOut: 10000
        };
        this.$toastr.info("Started", "Inference", options);
        let url = "/api/resultAI/inference/all?dataset_id=" + dataset_id
            + (this.query.studyDate__gte ? "&studyDate__gte=" + this.query.studyDate__gte : "")
            + (this.query.studyDate__lte ? "&studyDate__lte=" + this.query.studyDate__lte : "")
        // url+= "&force=true"
        axios.post(url)
          .then(response => {
            this.$toastr.info(response.data.message, "Inference", options);
          })
          .catch(error => {
            this.$toastr.error(error.response.data.message, "Inference", options);
          })
          .finally(()=>{
            this.aiprocessing.id=null
            this.aiprocessing.progress = 100
            this.removeProcess(process)
          })
      },
      async createAllReferralTask(dataset_id) {
        // External API 사용자 제한 검사
        if (this.shouldBlockWebFeatures) {
          this.$toastr.error(
            "API 계정은 프로덕션 환경에서 웹 Inference를 사용할 수 없습니다. External API를 이용해주세요.",
            "Inference Blocked"
          );
          return;
        }
        let process = "Referring All Images";
        this.addProcess(process);

        if (this.aiprocessing.id != null){
          return;
        }
        this.aiprocessing.id = 'notnull';
        this.aiprocessing.progress = 80;
        let options = {
          progressBar: true,
          positionClass: "toast-bottom-left",
          timeOut: 10000
        };
        this.$toastr.info("Started", "Referral All", options);

        // 1. EMR mode: retrieve images from PACS using EMR metadata
        if (this.settings.EMR.REQUIRE === 'true') {
          const emrType = this.settings.EMR.TYPE;
          const FINISHED_STATUSES = [FINISHED, FINISHED_TRANSMIT, FINISHED_PACS];

          for (const image of this.images) {
            let shouldProcess = false;

            if (emrType === 'mics') {
              // MICS: check stateEMR field
              shouldProcess = image.stateEMR === '미분석';
            } else if (emrType === 'bitcomputer') {
              // BitComputer: process if image not yet in MongoDB or analysis not finished
              if (!image.id) {
                // Image not yet fetched from PACS
                shouldProcess = true;
              } else {
                // Image exists in MongoDB - check if analysis finished
                const status = image.prediction_status || '';
                shouldProcess = !FINISHED_STATUSES.includes(status);
              }
            } else {
              // Default fallback for unknown EMR types
              shouldProcess = image.stateEMR === '미분석';
            }

            if (shouldProcess) {
              let body = {
                patientID: image.patientID,
                studyDate: image.studyDate,
                dataset_id: dataset_id,
                metadata: this.buildMetadata(image, 'emr')
              };
              axios.post("/api/image/pacsgetdicom", body)
                .then(response => {
                  let status = image.patientName + " 이미지 분석이 요청되었습니다.";
                  this.$toastr.info(response.data.message, status);
                })
                .catch(error => {
                  let status = image.patientName + " 이미지 조회가 실패하였습니다.";
                  this.$toastr.error(error.response.data.message, status);
                });
              await new Promise(resolve => setTimeout(resolve, 100));
            }
          }
        }
        // 2. PACS mode: retrieve images from PACS using PACS metadata
        else if (this.settings.PACS.REQUIRE === 'true') {
          for (const image of this.images) {
            // Only process images that don't exist in MongoDB yet (no ID)
            if (!image.id) {
              let body = {
                patientID: image.patientID || image.patient_id,
                studyDate: image.studyDate || image.study_date,
                dataset_id: dataset_id,
                metadata: this.buildMetadata(image, 'pacs')
              };
              axios.post("/api/image/pacsgetdicom", body)
                .then(response => {
                  let status = (image.patientName || image.patient_name) + " 이미지 분석이 요청되었습니다.";
                  this.$toastr.info(response.data.message, status);
                })
                .catch(error => {
                  let status = (image.patientName || image.patient_name) + " 이미지 조회가 실패하였습니다.";
                  this.$toastr.error(error.response.data.message, status);
                });
              await new Promise(resolve => setTimeout(resolve, 100));
            }
          }
        }
        // 3. Default mode: run inference on existing images
        else {
          let url = "/api/resultAI/inference/all?dataset_id=" + dataset_id
              + (this.query.studyDate__gte ? "&studyDate__gte=" + this.query.studyDate__gte : "")
              + (this.query.studyDate__lte ? "&studyDate__lte=" + this.query.studyDate__lte : "")
          axios.post(url)
            .then(response => {
              this.$toastr.info(response.data.message, "Inference", options);
            })
            .catch(error => {
              this.$toastr.error(error.response.data.message, "Inference", options);
            })
        }
        
        // this.images.forEach( async image => {
        //   if (image.stateMICS === '미분석') {
        //     // console.log(image)
        //     let body = {
        //       patientID: image.patientID, 
        //       studyDate: image.studyDate, 
        //       dataset_id: dataset_id,
        //       metadata: image.micsMeta, // can be null
        //     }
        //     axios.post("/api/image/pacsgetdicom", body)
        //       .then(response => {
        //         let status = image.patientName + " 이미지 분석이 요청되었습니다."
        //         this.$toastr.info(response.data.message, status);
        //       })
        //       .catch(error => {
        //         let status = image.patientName + " 이미지 조회가 실패하였습니다."
        //         this.$toastr.error(error.response.data.message, status);
        //       })
        //     await new Promise(resolve=> setTimeout(resolve,500));
        //   }
        // })
        this.aiprocessing.id=null
        this.aiprocessing.progress = 100
        this.removeProcess(process)
      },
      settingsModal() {
        if (this.importing.id != null) {
          this.$toastr.info("이미지 가져오기가 진행 중입니다.", "진행 중");
          return;
        }
        // Backup settings before opening modal
        this.settingsBackup = JSON.parse(JSON.stringify(this.settings));
        this.emrConfigJsonBackup = this.emrConfigJson;
        this.pacsConfigJsonBackup = this.pacsConfigJson;
        $("#settings").modal("show");
      },
      userSettingsModal() {
        $("#userSettings").modal("show");
      },
      closeSettingsModal() {
        // Restore settings from backup (discard changes)
        if (this.settingsBackup) {
          this.settings = JSON.parse(JSON.stringify(this.settingsBackup));
          this.emrConfigJson = this.emrConfigJsonBackup;
          this.pacsConfigJson = this.pacsConfigJsonBackup;
        }
        $("#settings").modal("hide");
      },
      saveSettings() {
        // Parse JSON configs back to settings object before saving
        this.parseConfigsToSettings();

        // Clear backup (changes are saved)
        this.settingsBackup = null;

        $("#settings").modal("hide");
        Dataset.saveSettings(this.dataset.id, this.settings).then(response => {
          this.$toastr.info(response.data, "Settings Saved");
        }).catch(error => {
          this.$toastr.error(error.response.data.message, "Settings Save Error");
        }).finally(() => {
          this.updatePage();
        });
      },
      testPacsConnection() {
        this.pacsTestLoading = true;
        this.pacsTestResult = null;

        // Parse current PACS config from JSON
        let pacsSettings;
        try {
          pacsSettings = JSON.parse(this.pacsConfigJson);
        } catch (e) {
          this.pacsTestResult = {
            success: false,
            message: "Invalid JSON configuration"
          };
          this.pacsTestLoading = false;
          return;
        }

        axios.post("/api/dataset/pacs/test", pacsSettings)
          .then(response => {
            this.pacsTestResult = {
              success: response.data.success,
              message: response.data.message
            };
          })
          .catch(error => {
            this.pacsTestResult = {
              success: false,
              message: (error.response && error.response.data && error.response.data.message) || "연결 테스트 실패"
            };
          })
          .finally(() => {
            this.pacsTestLoading = false;
          });
      },

      // ========== Settings JSON Config Methods ==========
      fetchIntegrationDefaults() {
        // Fetch integration config (types + defaults) from API
        axios.get('/api/dataset/integration/defaults')
          .then(response => {
            this.integrationConfig = response.data;
          })
          .catch(error => {
            console.error('Failed to fetch integration config:', error);
          });
      },

      initSettingsJson() {
        // Ensure EMR and PACS objects exist
        if (!this.settings.EMR) {
          this.settings.EMR = { REQUIRE: 'false', TYPE: 'none' };
        }
        if (!this.settings.PACS) {
          this.settings.PACS = { REQUIRE: 'false', REQUIRESEND: 'false', TYPE: 'none' };
        }

        // Set default type if not set
        if (!this.settings.EMR.TYPE) {
          this.settings.EMR.TYPE = 'none';
        }
        if (!this.settings.PACS.TYPE) {
          this.settings.PACS.TYPE = 'none';
        }
        if (!this.settings.PACS.REQUIRESEND) {
          this.settings.PACS.REQUIRESEND = 'false';
        }
        if (!this.settings.PACS.REPORT_TYPE) {
          this.settings.PACS.REPORT_TYPE = 'pdf';
        }

        // Upload mode default
        if (!this.settings.upload_mode) {
          this.settings.upload_mode = 'dicom';
        }

        // If type is 'none', show empty config, otherwise show current settings
        if (this.settings.EMR.TYPE === 'none') {
          this.emrConfigJson = '{}';
        } else {
          const emrConfig = { ...this.settings.EMR };
          delete emrConfig.REQUIRE;
          delete emrConfig.REQUIRESEND;
          delete emrConfig.TYPE;
          this.emrConfigJson = JSON.stringify(emrConfig, null, 2);
        }

        if (this.settings.PACS.TYPE === 'none') {
          this.pacsConfigJson = '{}';
        } else {
          const pacsConfig = { ...this.settings.PACS };
          delete pacsConfig.REQUIRE;
          delete pacsConfig.REQUIRESEND;
          delete pacsConfig.TYPE;
          delete pacsConfig.REPORT_TYPE;
          this.pacsConfigJson = JSON.stringify(pacsConfig, null, 2);
        }
      },

      onEmrTypeChange() {
        this.loadEmrDefaultConfig();
      },

      onPacsTypeChange() {
        this.loadPacsDefaultConfig();
      },

      loadEmrDefaultConfig() {
        const type = this.settings.EMR.TYPE || 'none';
        const emrConfig = this.integrationConfig.emr || {};
        const defaults = emrConfig.defaults || {};
        const defaultConfig = defaults[type] || {};
        this.emrConfigJson = JSON.stringify(defaultConfig, null, 2);
        this.emrConfigError = null;
        this.emrValidateResult = null;
      },

      loadPacsDefaultConfig() {
        const type = this.settings.PACS.TYPE || 'none';
        const pacsConfig = this.integrationConfig.pacs || {};
        const defaults = pacsConfig.defaults || {};
        const defaultConfig = defaults[type] || {};
        this.pacsConfigJson = JSON.stringify(defaultConfig, null, 2);
        this.pacsConfigError = null;
        this.pacsTestResult = null;
      },

      validateEmrConfig() {
        this.emrConfigError = null;
        this.emrValidateResult = null;

        try {
          const config = JSON.parse(this.emrConfigJson);
          const type = this.settings.EMR.TYPE;

          // Type-specific validation
          if (type === 'bitcomputer') {
            if (!config.ENDPOINT) {
              this.emrValidateResult = { success: false, message: 'ENDPOINT is required' };
              return;
            }
            if (!config.EXAM_CODE) {
              this.emrValidateResult = { success: false, message: 'EXAM_CODE is required' };
              return;
            }
          } else if (type === 'mics') {
            if (!config.IP) {
              this.emrValidateResult = { success: false, message: 'IP is required' };
              return;
            }
          }

          this.emrValidateResult = { success: true, message: 'Valid' };
        } catch (e) {
          this.emrConfigError = 'Invalid JSON: ' + e.message;
        }
      },

      validatePacsConfig() {
        this.pacsConfigError = null;
        this.pacsTestResult = null;

        try {
          const config = JSON.parse(this.pacsConfigJson);

          // Basic validation
          if (!config.IP) {
            this.pacsTestResult = { success: false, message: 'IP is required' };
            return;
          }
          if (!config.PORT) {
            this.pacsTestResult = { success: false, message: 'PORT is required' };
            return;
          }
          if (!config.AETITLE) {
            this.pacsTestResult = { success: false, message: 'AETITLE is required' };
            return;
          }

          this.pacsTestResult = { success: true, message: 'Valid JSON' };
        } catch (e) {
          this.pacsConfigError = 'Invalid JSON: ' + e.message;
        }
      },

      parseConfigsToSettings() {
        // Parse JSON configs back to settings before saving
        // When Type is "none", clear config fields; otherwise merge JSON config

        // EMR: preserve only REQUIRE and TYPE, replace everything else with JSON config
        const emrRequire = this.settings.EMR.REQUIRE;
        const emrType = this.settings.EMR.TYPE;
        this.settings.EMR = {
          REQUIRE: emrRequire,
          TYPE: emrType
        };

        if (emrType !== 'none') {
          try {
            const emrConfig = JSON.parse(this.emrConfigJson);
            Object.assign(this.settings.EMR, emrConfig);
          } catch (e) {
            console.error('Failed to parse EMR config:', e);
          }
        }

        // PACS: preserve REQUIRE, REQUIRESEND, TYPE, and REPORT_TYPE, replace everything else with JSON config
        const pacsRequire = this.settings.PACS.REQUIRE;
        const pacsRequireSend = this.settings.PACS.REQUIRESEND;
        const pacsType = this.settings.PACS.TYPE;
        const pacsReportType = this.settings.PACS.REPORT_TYPE || 'pdf';
        this.settings.PACS = {
          REQUIRE: pacsRequire,
          REQUIRESEND: pacsRequireSend,
          TYPE: pacsType,
          REPORT_TYPE: pacsReportType
        };

        if (pacsType !== 'none') {
          try {
            const pacsConfig = JSON.parse(this.pacsConfigJson);
            Object.assign(this.settings.PACS, pacsConfig);
          } catch (e) {
            console.error('Failed to parse PACS config:', e);
          }
        }
      },
      // ========== End Settings JSON Config Methods ==========
      updateAllAITask(dataset_id) {
        // External API 사용자 제한 검사
        if (this.shouldBlockWebFeatures) {
          this.$toastr.error(
            "API 계정은 프로덕션 환경에서 웹 Inference를 사용할 수 없습니다. External API를 이용해주세요.",
            "Inference Blocked"
          );
          return;
        }
        let process = "Updating All Predictions";
        this.addProcess(process);

        if (this.aiprocessing.id != null){
          return;
        }
        this.aiprocessing.id = 'notnull';
        this.aiprocessing.progress = 80;
        let options = {
          progressBar: true,
          positionClass: "toast-bottom-left",
          timeOut: 10000
        };
        this.$toastr.info("Started", "Inference ALL", options);
        axios.put("/api/resultAI/inference/all?dataset_id=" + dataset_id)
          .then(response => {
            this.$toastr.info(response.data.message, "Inference ALL", options);
          })
          .catch(error => {
            this.$toastr.error(error.response.data.message, "Inference ALL", options);
          })
          .finally(()=>{
            this.aiprocessing.id=null
            this.aiprocessing.progress = 100
            this.removeProcess(process)
          })
      },
      onProcessAIClick(image) {
        // Check if image has an ID (exists in MongoDB)
        if (image.id) {
          // Image already in MongoDB, just run inference
          this.startInference(image);
        } else if (this.settings.EMR.REQUIRE === 'true') {
          // EMR mode: retrieve from EMR first
          this.startEMRRetrieval(image);
        } else if (this.settings.PACS.REQUIRE === 'true') {
          // PACS mode: retrieve from PACS first
          this.startPACSRetrieval(image);
        } else {
          // Fallback: try inference anyway
          this.startInference(image);
        }
      },

      isInferenceTerminal(status) {
        return TERMINAL_PREDICTION_STATUSES.includes(status);
      },
      isInferenceActive(status) {
        return ACTIVE_PREDICTION_STATUSES.includes(status);
      },
      getInferencePollingIntervalMs() {
        const elapsed = this.inferencePollingStartedAt
          ? Date.now() - this.inferencePollingStartedAt
          : 0;
        if (elapsed < 60 * 1000) return 5000;
        if (elapsed < 5 * 60 * 1000) return 10000;
        return 30000;
      },
      clearInferencePolling(imageId) {
        this.$delete(this.pendingInferenceImageIds, imageId);
        if (Object.keys(this.pendingInferenceImageIds).length === 0) {
          this.clearAllInferencePolling();
        }
      },
      clearAllInferencePolling() {
        if (this.inferencePollingTimer) {
          clearTimeout(this.inferencePollingTimer);
          this.inferencePollingTimer = null;
        }
        Object.keys(this.pendingInferenceImageIds).forEach(imageId => {
          this.$delete(this.pendingInferenceImageIds, imageId);
        });
        this.inferencePollingStartedAt = null;
      },
      resumeInferencePollingForActiveImages() {
        this.images.forEach(image => {
          if (image.id && this.isInferenceActive(image.prediction_status)) {
            this.startInferenceStatusPolling(image.id, { resumed: true, notify: false });
          }
        });
      },
      startInferenceStatusPolling(imageId, options = {}) {
        const existing = this.pendingInferenceImageIds[imageId];
        const notify = existing ? existing.notify || options.notify !== false : options.notify !== false;
        this.$set(this.pendingInferenceImageIds, imageId, { notify });
        if (!this.inferencePollingStartedAt) {
          // Resumed polling after refresh/re-entry should start at the slower
          // backoff tier because the original inference start time is unknown.
          this.inferencePollingStartedAt = options.resumed
            ? Date.now() - (60 * 1000)
            : Date.now();
        }
        if (this.inferencePollingTimer) {
          return;
        }

        const timeoutMs = 10 * 60 * 1000;
        const scheduleNextPoll = () => {
          if (Object.keys(this.pendingInferenceImageIds).length === 0) {
            this.clearAllInferencePolling();
            return;
          }
          this.inferencePollingTimer = setTimeout(poll, this.getInferencePollingIntervalMs());
        };
        const poll = () => {
          this.inferencePollingTimer = null;
          this.updatePageSilently()
            .then(() => {
              const pendingIds = Object.keys(this.pendingInferenceImageIds);
              pendingIds.forEach(imageId => {
                const image = this.images.find(img => String(img.id) === String(imageId));
                const status = image && image.prediction_status;
                if (!this.isInferenceTerminal(status)) {
                  return;
                }

                const pending = this.pendingInferenceImageIds[imageId] || {};
                this.$delete(this.pendingInferenceImageIds, imageId);
                if (pending.notify) {
                  if (status === FAILED) {
                    this.$toastr.error('AI analysis failed', 'Inference');
                  } else {
                    this.$toastr.success('Analysis complete', 'Inference');
                  }
                }
              });

              if (Object.keys(this.pendingInferenceImageIds).length === 0) {
                this.clearAllInferencePolling();
                return;
              }
              if (Date.now() - this.inferencePollingStartedAt >= timeoutMs) {
                this.clearAllInferencePolling();
                this.$toastr.warning('Analysis is still running. Refresh later to check status.', 'Inference');
                return;
              }
              scheduleNextPoll();
            })
            .catch(() => {
              if (Date.now() - this.inferencePollingStartedAt < timeoutMs) {
                scheduleNextPoll();
                return;
              }
              this.clearAllInferencePolling();
              this.$toastr.warning('Analysis is still running. Refresh later to check status.', 'Inference');
            });
        };
        scheduleNextPoll();
      },
      startInference(image) {
        // External API 사용자 제한 검사
        if (this.shouldBlockWebFeatures) {
          this.$toastr.error(
            "API 계정은 프로덕션 환경에서 웹 Inference를 사용할 수 없습니다. External API를 이용해주세요.",
            "Inference Blocked"
          );
          return;
        }
        let options = {
          progressBar: true,
          positionClass: "toast-bottom-left",
          timeOut: 5000
        };
        this.$toastr.info("Started", "Inference", options);
        axios.post("/api/resultAI/inference/?original_id=" + image.id)
        .then(response => {
          this.$toastr.info(response.data.message, "Inference", options)
          this.startInferenceStatusPolling(image.id);
        })
        .catch(error => {
          this.$toastr.error(error.response.data.message, "Inference", options);
        })
      },
      onBatchDownloadPDFs() {
        var self = this;
        var rKey = this.resultKey;

        // 필터링: prediction_status가 'Finished'인 이미지만 포함
        var imagesWithResults = this.images.filter(function(img) {
          var isFinished = img.prediction_status && TERMINAL_FINISHED.indexOf(img.prediction_status) !== -1;
          var hasXAIFNResult = img.results && img.results[rKey];
          return isFinished || hasXAIFNResult;
        });

        var imageIds = imagesWithResults.map(function(img) { return img.id; });

        if (imageIds.length === 0) {
          this.$toastr.warning("다운로드할 결과지가 없습니다. AI 분석이 완료된 이미지가 필요합니다.", "결과지 다운로드");
          return;
        }

        this.batchDownloading = true;
        var options = {
          progressBar: true,
          positionClass: "toast-bottom-left",
          timeOut: 0  // 자동 닫힘 비활성화
        };

        // 기존 "ZIP 생성 중" 토스트 제거
        this.$toastr.clear();
        this.$toastr.info("ZIP 생성 중...", "결과지 일괄 다운로드", options);

        // 1단계: 다운로드 요청 (비동기)
        axios.post("/api/resultAI/download-pdfs/batch", {
          image_ids: imageIds,
          format: this.downloadSettings.format,
          quality: this.downloadSettings.quality,
          page_mode: this.downloadSettings.page_mode
        })
        .then(function(response) {
          if (response.data.status === 'ready') {
            // 캐시 HIT: 즉시 다운로드
            self.triggerBatchDownload(response.data.download_url, imageIds.length);
          } else if (response.data.status === 'processing') {
            // 캐시 MISS: 폴링 시작
            self.pollBatchDownloadStatus(response.data.task_id, imageIds.length);
          }
        })
        .catch(function(error) {
          console.error('Batch download error:', error);
          self.$toastr.clear();
          var errorMessage = "결과지 다운로드 중 오류가 발생했습니다.";
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          }
          self.$toastr.error(errorMessage, "결과지 다운로드 실패");
          self.batchDownloading = false;
        });
      },
      pollBatchDownloadStatus(taskId, imageCount) {
        var self = this;
        var pollCount = 0;
        var maxPolls = 300;  // 최대 5분 (1초 간격 * 300회)

        // 기존 폴링이 있으면 정리
        if (this.batchDownloadPollInterval) {
          clearInterval(this.batchDownloadPollInterval);
        }

        this.batchDownloadPollInterval = setInterval(function() {
          pollCount++;

          if (pollCount > maxPolls) {
            clearInterval(self.batchDownloadPollInterval);
            self.batchDownloadPollInterval = null;
            self.$toastr.clear();
            self.$toastr.error("ZIP 생성 시간이 초과되었습니다. 다시 시도해주세요.", "타임아웃");
            self.batchDownloading = false;
            return;
          }

          axios.get("/api/resultAI/download-pdfs/batch/status/" + taskId)
            .then(function(response) {
              if (response.data.status === 'ready') {
                clearInterval(self.batchDownloadPollInterval);
                self.batchDownloadPollInterval = null;
                self.triggerBatchDownload(response.data.download_url, imageCount);
              } else if (response.data.status === 'failed') {
                clearInterval(self.batchDownloadPollInterval);
                self.batchDownloadPollInterval = null;
                self.$toastr.clear();
                var errorMsg = response.data.error || "ZIP 생성에 실패했습니다.";
                self.$toastr.error(errorMsg, "결과지 다운로드 실패");
                self.batchDownloading = false;
              }
              // 'processing' 상태면 계속 폴링
            })
            .catch(function(error) {
              clearInterval(self.batchDownloadPollInterval);
              self.batchDownloadPollInterval = null;
              console.error('Status polling error:', error);
              self.$toastr.clear();
              self.$toastr.error("상태 확인 중 오류가 발생했습니다.", "오류");
              self.batchDownloading = false;
            });
        }, 1000);  // 1초 간격 폴링
      },
      triggerBatchDownload(url, imageCount) {
        var self = this;

        // "ZIP 생성 중" 토스트 제거
        this.$toastr.clear();

        // 파일명 생성: reports_YYYYMMDD.zip
        var today = new Date();
        var dateStr = today.getFullYear() +
                      String(today.getMonth() + 1).padStart(2, '0') +
                      String(today.getDate()).padStart(2, '0');
        var filename = 'reports_' + dateStr + '.zip';

        // presigned URL로 다운로드
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.$toastr.success(imageCount + "개의 결과지가 다운로드되었습니다.", "결과지 다운로드 완료");
        this.batchDownloading = false;
      },
      getUsers() {
        Dataset.getUsers(this.dataset.id).then(response => {
          this.users = response.data;
        });
      },
      downloadExport(id) {
        Export.download(id, this.institutionName);
      },
      getExports() {
        Dataset.getExports(this.dataset.id).then(response => {
          this.datasetExports = response.data;
        });
      },
      resetMetadata() {
        let r = confirm("You can not undo reseting of all metadata in"
          + "this dataset. This includes metadata of images"
          + "and annotations.");
        
        if (r) {
          Dataset.resetMetadata(this.dataset.id);
        }
      },
      getStats() {
        Dataset.getStats(this.dataset.id).then(response => {
          this.stats = response.data;
        });
      },
      exportModal() {
        if (this.exporting.id != null) {
          this.$toastr.info("내보내기가 진행 중입니다.", "진행 중");
          return;
        }
        $("#exportDataset").modal("show");
      },
      exportCOCO() {
        $("#exportDataset").modal("hide");
        Dataset.exportingCOCO(this.dataset.id, this.exporting.categories)
          .then(response => {
            let id = response.data.id;
            this.exporting.id = id;
          })
          .catch(error => {
            this.axiosReqestError("Exporting COCO", error.response.data.message);
          })
          .finally(() => this.removeProcess(process));
      },
      removeFolder(folder) {
        // let index = this.folders.indexOf(folder);
        // this.folders.splice(index + 1, this.folders.length);
        this.folders = folder
      },
      importModal() {
        // External API 사용자 제한 검사
        if (this.shouldBlockWebFeatures) {
          this.$toastr.error(
            "API 계정은 프로덕션 환경에서 웹 업로드를 사용할 수 없습니다. External API를 이용해주세요.",
            "Upload Blocked"
          );
          return;
        }
        if (this.importing.id != null) {
          this.$toastr.info("이미지 가져오기가 진행 중입니다.", "진행 중");
          return;
        }

        // Set default upload mode from component settings (synced with server)
        this.uploadMode = this.settings.upload_mode || 'dicom';
        // Reset JPG form
        this.jpegForm = { name: '', age: null, sex: '', studyDate: '', patientId: '' };
        this.jpegFile = null;
        this.jpegUploading = false;

        $("#imgUpload").modal("show");
      },
      submitJpeg: function() {
        var self = this;
        var info = this.jpegForm;

        // Required field validation
        if (!info.name || !info.age || !info.sex) {
          this.$toastr.e('환자 이름, 나이, 성별은 필수 입력 항목입니다.');
          return;
        }
        if (!this.jpegFile) {
          this.$toastr.e('업로드할 파일을 선택해주세요.');
          return;
        }

        var patientInfo = {
          name: info.name,
          age: info.age,
          sex: info.sex,
          studyDate: info.studyDate ? info.studyDate.replace(/-/g, '') : '',
          patientId: info.patientId || ''
        };

        this.jpegUploading = true;

        Dataset.uploadJpeg(
          this.dataset.id,
          this.jpegFile,
          patientInfo
        ).then(function(response) {
          var data = response.data;

          // Success — close modal
          var closeBtn = document.querySelector('#imgUpload [data-dismiss="modal"]');
          if (closeBtn) closeBtn.click();

          if (data.duplicate) {
            // Same file and same patient info: the existing row is the upload (#441).
            // A different patient creates a new row, so nothing is ever overwritten.
            self.$toastr.info('같은 환자 정보로 이미 등록된 이미지입니다.');
            self.getData();
          } else {
            self.$toastr.s('업로드가 시작되었습니다.');
            self.getData();  // 즉시 테이블 갱신 (업로드 중 상태 표시)
            self.pollImageCompletion([data.id]);
          }

          self.jpegUploading = false;
        }).catch(function(error) {
          self.jpegUploading = false;
          var msg = (error.response && error.response.data && error.response.data.message)
            || error.message || '업로드 실패';
          self.$toastr.e(msg);
        });
      },
      pollImageCompletion: function(imageIds) {
        var self = this;
        var maxPolls = 60;  // 2min max (2s * 60)
        var pollCount = 0;
        var interval = setInterval(function() {
          pollCount++;
          if (pollCount >= maxPolls) {
            clearInterval(interval);
            self.$toastr.w('이미지 처리 시간이 초과되었습니다. 페이지를 새로고침해주세요.');
            return;
          }
          Dataset.checkImageIds(imageIds).then(function(res) {
            if (res.data.existing && res.data.existing.length > 0) {
              clearInterval(interval);
              self.$toastr.s('이미지 처리가 완료되었습니다.');
              self.getData();
            }
          });
        }, 2000);
      },
      async submit() {
        // External API 사용자 제한 검사
        if (this.shouldBlockWebFeatures) {
          this.$toastr.error(
            "API 계정은 프로덕션 환경에서 웹 업로드를 사용할 수 없습니다. External API를 이용해주세요.",
            "Upload Blocked"
          );
          return;
        }
        var process = "Uploading Image";
        this.addProcess(process);

        // selectedFiles 사용 (드래그앤드롭 및 파일 선택 모두 지원)
        var filesToUpload = this.selectedFiles.length > 0
          ? this.selectedFiles
          : Array.from(document.getElementById("imagetoupload").files);

        var options = {
          progressBar: true,
          positionClass: "toast-bottom-left",
          timeOut: 10000
        };
        var failOptions = {
          progressBar: true,
          positionClass: "toast-bottom-left",
          timeOut: 20000,  // 실패 토스트는 20초
          closeButton: true
        };
        var persistentOptions = {
          progressBar: false,
          positionClass: "toast-bottom-left",
          timeOut: 0,  // 수동으로 제거할 때까지 유지
          closeButton: false
        };

        var totalFiles = filesToUpload.length;
        if (totalFiles === 0) {
          this.$toastr.warning("업로드할 파일을 선택해주세요.", "파일 없음", options);
          this.removeProcess(process);
          return;
        }

        // 1. 업로드 진행중 토스트 (하나만, 끝날 때까지 유지)
        this.$toastr.info(
          totalFiles + "개 파일 업로드 중...",
          "업로드 진행",
          persistentOptions
        );

        // 업로드 상태 초기화 (이전 업로드의 timeout 취소)
        if (this.importing.timeout) {
          clearTimeout(this.importing.timeout);
          this.importing.timeout = null;
        }
        this.importing.id = 'notnull';
        this.importing.progress = 0;

        // 성공한 업로드 정보: [{id, original_filename}, ...]
        var successfulUploads = [];
        // S3 업로드 실패한 파일 정보: [{file, name}, ...]
        var failedS3Uploads = [];

        // 2. S3 업로드 (progress 0% ~ 50%)
        for (var i = 0; i < totalFiles; i++) {
          var currentFile = filesToUpload[i];
          try {
            var response = await Dataset.uploadImg(this.dataset.id, currentFile);
            // 서버가 id와 original_filename을 반환
            successfulUploads.push({
              id: response.data.id,
              original_filename: response.data.original_filename
            });
          } catch (error) {
            failedS3Uploads.push({ file: currentFile, name: currentFile.name });
          }
          this.importing.progress = (i + 1) / totalFiles * 50;  // S3 업로드는 50%까지
          await new Promise(function(resolve) { setTimeout(resolve, 500); });
        }

        // S3 업로드 실패한 파일 재시도 (1회)
        if (failedS3Uploads.length > 0) {
          var retryFailed = [];
          for (var j = 0; j < failedS3Uploads.length; j++) {
            var retryFile = failedS3Uploads[j];
            try {
              var retryResponse = await Dataset.uploadImg(this.dataset.id, retryFile.file);
              successfulUploads.push({
                id: retryResponse.data.id,
                original_filename: retryResponse.data.original_filename
              });
            } catch (error) {
              retryFailed.push(retryFile);
            }
          }
          failedS3Uploads = retryFailed;
        }

        // 3. Worker 처리 완료까지 폴링 (progress 50% ~ 100%)
        // ID 기반으로 Worker 완료 여부 확인 (날짜 필터 영향 없음)
        var attempts = 0;
        var maxAttempts = 30;  // 최대 60초 (30 * 2초)
        var uploadedIds = successfulUploads.map(function(u) { return u.id; });
        var lastExistingCount = 0;
        var noProgressCount = 0;
        var checkResult = { existing: [], missing: uploadedIds };

        this.importing.progress = 55;

        while (attempts < maxAttempts && uploadedIds.length > 0) {
          await new Promise(function(resolve) { setTimeout(resolve, 2000); });

          try {
            // ID 기반으로 Worker 완료 확인 (날짜 필터 영향 없음)
            var response = await Dataset.checkImageIds(uploadedIds);
            checkResult = response.data;

            // 목록 새로고침 (처리된 이미지 표시)
            await this.updatePageSilently();
          } catch (e) {
            // 폴링 에러는 무시하고 계속 진행
          }

          // Worker 처리 진행률 업데이트 (실제 처리 비율 기반)
          var processedRatio = uploadedIds.length > 0
            ? checkResult.existing.length / uploadedIds.length
            : 1;
          this.importing.progress = 50 + processedRatio * 50;  // 50% ~ 100%

          // 모든 파일 처리 완료
          if (checkResult.missing.length === 0) {
            this.importing.progress = 95;
            await new Promise(function(resolve) { setTimeout(resolve, 300); });
            break;
          }

          attempts++;

          // 최소 15회(30초)는 폴링, 그 후 진행 없으면 조기 종료
          if (attempts >= 15) {
            if (checkResult.existing.length === lastExistingCount) {
              noProgressCount++;
              if (noProgressCount >= 5) {
                break;
              }
            } else {
              noProgressCount = 0;
            }
          }
          lastExistingCount = checkResult.existing.length;
        }

        // 4. 모든 토스트 제거
        this.$toastr.clear();

        // 5. 업로드 프로세스 종료
        this.removeProcess(process);
        this.importing.progress = 100;
        this.selectedFiles = [];

        // 1초 후 프로그레스바 리셋 (100% 완료 상태를 보여준 후)
        await new Promise(function(resolve) { setTimeout(resolve, 1000); });
        this.importing.progress = 0;
        this.importing.id = null;

        // 6. 마지막 새로고침 (폴링에서 놓친 데이터 반영) - await 필요
        await this.updatePageSilently();

        // 7. 결과 토스트 (S3 업로드 + Worker 처리 결과)
        // Worker 실패 파일명 찾기
        var workerFailedFiles = [];
        var missingIds = checkResult.missing;
        for (var k = 0; k < successfulUploads.length; k++) {
          if (missingIds.indexOf(successfulUploads[k].id) !== -1) {
            workerFailedFiles.push(successfulUploads[k].original_filename);
          }
        }

        var s3FailedCount = failedS3Uploads.length;
        var workerFailedCount = workerFailedFiles.length;
        var successCount = checkResult.existing.length;

        if (s3FailedCount === 0 && workerFailedCount === 0) {
          // 모두 성공
          this.$toastr.success(successCount + "개 이미지 업로드 완료", "완료", options);
        } else if (successCount > 0) {
          // 일부 성공
          this.$toastr.success(successCount + "개 업로드 완료", "완료", options);
          if (s3FailedCount > 0) {
            var s3FailedNames = failedS3Uploads.map(function(f) { return f.name; }).join(", ");
            this.$toastr.warning("S3 업로드 실패: " + s3FailedNames, s3FailedCount + "개 파일", failOptions);
          }
          if (workerFailedCount > 0) {
            var workerFailedNames = workerFailedFiles.join(", ");
            this.$toastr.warning("처리 실패: " + workerFailedNames, workerFailedCount + "개 파일 (DICOM 오류)", failOptions);
          }
        } else {
          // 모두 실패
          var allFailedNames = failedS3Uploads.map(function(f) { return f.name; }).concat(workerFailedFiles).join(", ");
          this.$toastr.error("실패: " + allFailedNames, "업로드 실패", failOptions);
        }
      },  
      importCOCO() {
        let uploaded = document.getElementById("coco");
        Dataset.uploadCoco(this.dataset.id, uploaded.files[0])
          .then(response => {
            let id = response.data.id;
            this.importing.id = id;
          })
          .catch(error => {
            this.axiosReqestError("Importing COCO", error.response.data.message);
          })
          .finally(() => this.removeProcess(process));
      },
      mouseMove(event) {
        let element = this.$refs.sidebar;
  
        let sidebarWidth = element.offsetWidth;
        let clickWidth = event.x;
        let pixelsFromSide = Math.abs(sidebarWidth - clickWidth);
  
        this.sidebar.drag = pixelsFromSide < 4;
  
        if (this.sidebar.canResize) {
          event.preventDefault();
          let max = window.innerWidth * 0.5;
          this.sidebar.width = Math.min(Math.max(event.x, 150), max);
          localStorage.setItem("dataset/sideWidth", this.sidebar.width)
        }
      },
      startDrag() {
        this.mouseDown = true;
        this.sidebar.canResize = this.sidebar.drag;
      },
      stopDrag() {
        this.mouseDown = false;
        this.sidebar.canResize = false;
      },
      // Helper to convert an array of objects to CSV,
      // fetching ORD_SEQ and BNCH_NM from emrMeta
      objectsToCSV(data, columns, delimiter = ",") {
        // Build the header row
        const header = columns.join(delimiter);
        // Build each CSV row
        const rows = data.map(obj =>
          columns
            .map(col => {
              let cell;
              if (col === "ORD_SEQ" || col === "BNCH_NM") {
                cell = obj.emrMeta && obj.emrMeta[col] != null ? obj.emrMeta[col] : "";
              } else {
                cell = obj[col] != null ? obj[col] : "";
              }
              cell = String(cell);
              // Escape cell if it contains special characters
              if (cell.includes(delimiter) || cell.includes('"') || cell.includes("\n")) {
                cell = `"${cell.replace(/"/g, '""')}"`;
              }
              return cell;
            })
            .join(delimiter)
        );
        return [header, ...rows].join("\n");
      },

      // Method to trigger CSV export
      exportCSV() {
        // Define the columns you want in your CSV
        const columns = [
          "studyDate",
          "orderID",
          "studyDate_image",
          "stateEMR",
          "patientID",
          "patientName",
          "patientSex",
          "patientAge",
          "ORD_SEQ",
          "BNCH_NM"
        ];
        // Remove duplicates based on patientID.
        // This creates a Map where each key is a patientID and only the first occurrence is kept.
        const uniqueImages = Array.from(
          new Map(this.images.map(item => [item.patientID, item])).values()
        );
        // Generate the CSV string from uniqueImages
        const csvString = this.objectsToCSV(uniqueImages, columns);
        // Create a Blob from the CSV string
        const bom = "\uFEFF"; // UTF-8 BOM
        const blob = new Blob([bom + csvString], { type: "text/csv;charset=utf-8;" });
        // Create a temporary URL for the Blob
        const url = URL.createObjectURL(blob);
        // Use your existing downloadURI method to trigger the download
        this.downloadURI(url, `${this.institutionName}_export.csv`);
      },
      saveFilterState() {
        const filterState = {
          query: this.query,
          stateEMR: this.stateEMR,
          limit: this.limit,
          order: this.order,
          ascending: this.ascending
        };
        sessionStorage.setItem('dataset/filterState', JSON.stringify(filterState));
      },

      loadFilterState() {
        const savedState = sessionStorage.getItem('dataset/filterState');
        if (savedState) {
          const filterState = JSON.parse(savedState);
          this.query = filterState.query;
          this.stateEMR = filterState.stateEMR;
          this.limit = filterState.limit;
          this.order = filterState.order;
          this.ascending = filterState.ascending;
        }
      },
    },
    computed: {
      resultKey() {
        return this.$store.state.info.resultKey || 'XAIFN';
      },
      queryAnnotated() {
        // let showAnnotated = this.panel.showAnnotated;
        // let showNotAnnotated = this.panel.showNotAnnotated;

        // if (showAnnotated && showNotAnnotated) return null;
        // if (!showAnnotated && !showNotAnnotated) return " ";

        return this.showAnnotated;
      },
      institutionName() {
        // dataset owner의 기관명 표시
        if (this.dataset && this.dataset.institution_name) {
          return this.dataset.institution_name;
        }
        // fallback: dataset.name (username과 동일)
        return this.dataset ? this.dataset.name : '';
      },
      // External API 사용자 기능 제한 관련
      isApiOnlyUser() {
        return this.$store.getters['user/isApiOnlyUser'];
      },
      isProductionEnv() {
        return this.$store.state.info.apiKeyEnv === 'live';
      },
      shouldBlockWebFeatures() {
        return this.isApiOnlyUser && this.isProductionEnv;
      },
      estimatedSize() {
        var sizeMap;
        if (this.downloadSettings.page_mode === 'simple') {
          sizeMap = {
            'high': '~1.0MB',
            'standard': '~350KB',
            'low': '~160KB'
          };
        } else {
          // full (4페이지) - PDF/JPG(ZIP) 모두 유사한 용량
          sizeMap = {
            'high': '~2.5MB',
            'standard': '~1.0MB',
            'low': '~500KB'
          };
        }
        return sizeMap[this.downloadSettings.quality] || '~1.0MB';
      }
    },
    // sockets: {
    //   taskProgress(data) {
    //     if (data.id === this.scan.id) {
    //       this.scan.progress = data.progress;
    //     }
  
    //     if (data.id === this.generate.id) {
    //       this.generate.progress = data.progress;
    //     }
  
    //     if (data.id === this.importing.id) {
    //       this.importing.progress = data.progress;
    //     }
  
    //     if (data.id === this.exporting.id) {
    //       this.exporting.progress = data.progress;
    //     }
    //   },
    //   annotating(data) {
    //     let image = this.images.find(i => i.id == data.image_id);
    //     if (image == null) return;
  
    //     if (data.active) {
    //       let found = image.annotating.indexOf(data.username);
    //       if (found < 0) {
    //         image.annotating.push(data.username);
    //       }
    //     } else {
    //       image.annotating.splice(image.annotating.indexOf(data.username), 1);
    //     }
    //   }
    // },
    watch: {
      'dataset.id': function(newId) {
        if (newId) {
          this.loadDownloadSettings();
        }
      },
      tab(tab) {
        sessionStorage.setItem("dataset/tab", tab);
        if (tab == "members") this.getUsers();
        if (tab == "statistics") this.getStats();
        if (tab == "exports") this.getExports();
      },
      order(order) {
        sessionStorage.setItem("dataset/order", order);
        // this.updatePage();
      },
      queryAnnotated() {
        this.updatePage();
      },
      "selected.categories"() {
        this.updatePage();
      },
      folders() {
        this.updatePage();
      },
      "sidebar.drag"(canDrag) {
        let el = this.$refs.sidebar;
        if (canDrag) {
          this.$el.style.cursor = "ew-resize";
          el.style.borderRight = "4px solid #383c4a";
        } else {
          this.$el.style.cursor = "default";
          el.style.borderRight = "";
        }
      },
      "importing.progress"(progress) {
        // 업로드 함수에서 직접 관리 (watch에서 setTimeout 사용 시 타이밍 문제 발생)
      },
      "exporting.progress"(progress) {
        if (progress >= 100) {
          setTimeout(() => {
            this.exporting.progress = 0;
            this.exporting.id = null;
            this.getExports();
          }, 1000);
        }
      }
    },
    beforeRouteUpdate() {
      this.dataset.id = this.identifier;
      this.updatePage();
    },
    created() {
      let tab = sessionStorage.getItem("dataset/tab");
      let order = sessionStorage.getItem("dataset/order");
      let sideWidth = sessionStorage.getItem("dataset/sideWidth");
      
      if (sideWidth !== null) this.sidebar.width = parseInt(sideWidth);
      if (tab !== null) this.tab = tab;
      if (order !== null) this.order = order;

      // Load saved filter state
      this.loadFilterState();
  
      this.dataset.id = this.identifier;
      this.updatePage();
    },
    mounted() {
      // Fetch integration defaults for settings modal
      this.fetchIntegrationDefaults();
      // Load download settings for this dataset
      this.loadDownloadSettings();
    },
    destroyed() {
      // cleanup: 폴링 interval 정리
      this.clearAllInferencePolling();
      if (this.batchDownloadPollInterval) {
        clearInterval(this.batchDownloadPollInterval);
        this.batchDownloadPollInterval = null;
      }
    }
  };
  </script>
  
  <style scoped>
  /* JSON Config Editor */
  .code-editor {
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 12px;
    line-height: 1.4;
    background-color: #f8f9fa;
    border: 1px solid #ced4da;
    resize: vertical;
  }
  .code-editor:focus {
    background-color: #fff;
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }

  .breadcrumb {
    padding: 0px;
    margin: 5px 0;
  }

  .btn-link {
    padding: 0px;
  }
  
  .sidebar .title {
    color: white;
  }
  
  .progress {
    padding: 2px;
    height: 24px;
  }
  
  .sidebar {
    height: 100%;
    position: fixed;
    color: white;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: #4b5162;
    overflow-x: hidden;
    overflow-y: auto;
    padding-top: 60px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
  }
  
  .sidebar .closebtn {
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 36px;
    margin-left: 50px;
  }
  
  .sidebar-title {
    color: white;
  }
  
  .sidebar-section-buttons {
    margin: 5px;
  }
  
  .sidebar-section {
    margin: 5px;
    border-radius: 5px;
    background-color: #383c4a;
    padding: 0 5px 2px 5px;
    overflow: auto;
  }

  /* 사이드바 안내 텍스트 스타일 */
  .sidebar-guide-text {
    color: #adb5bd;
    font-size: 13px;
    margin: 0 5px 5px 5px;
    line-height: 1.4;
    text-align: left;
  }

  /* DICOM 파일 경고 텍스트 */
  .dicom-warning {
    color: #dc3545;
    font-size: 12px;
    margin-top: 8px;
    margin-bottom: 0;
  }

  /* 업로드 안내 텍스트 */
  .upload-instruction {
    color: #333;
    font-size: 14px;
    margin-bottom: 15px;
  }

  /* 드래그앤드롭 영역 */
  .drop-zone {
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 40px 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: #fafafa;
  }

  .drop-zone:hover {
    border-color: #007bff;
    background-color: #f0f7ff;
  }

  .drop-zone.drag-over {
    border-color: #28a745;
    background-color: #e8f5e9;
  }

  .drop-zone-content {
    color: #666;
  }

  .drop-zone-content i {
    color: #999;
    margin-bottom: 10px;
  }

  .drop-zone-content p {
    margin: 5px 0;
  }

  .drop-zone-hint {
    font-size: 12px;
    color: #999;
  }

  .drop-zone-overlay {
    color: #28a745;
  }

  .drop-zone-overlay i {
    margin-bottom: 10px;
  }

  .drop-zone-overlay p {
    font-size: 16px;
    font-weight: bold;
  }

  .hidden-file-input {
    display: none;
  }

  /* 선택된 파일 목록 */
  .selected-files {
    margin-top: 20px;
    border-top: 1px solid #eee;
    padding-top: 15px;
  }

  .selected-files-header {
    margin-bottom: 10px;
    color: #333;
  }

  .selected-files-list {
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 150px;
    overflow-y: auto;
  }

  .selected-files-list li {
    padding: 5px 0;
    border-bottom: 1px solid #f0f0f0;
    font-size: 13px;
    color: #555;
  }

  .selected-files-list li i {
    margin-right: 8px;
    color: #999;
  }

  .file-size {
    color: #999;
    font-size: 12px;
  }

  /* 조회 요약 텍스트 */
  .query-summary {
    color: #000;
    font-size: 13px;
    margin: 5px 0 10px 0;
  }

  /* 환경 설정 버튼 (최하단 고정) */
  .sidebar-settings-bottom {
    margin: 5px;
    margin-top: auto;
    padding-top: 10px;
    display: flex;
    align-items: center;
  }

  /* Admin 설정 버튼 - 좌하단, 주황색 */
  .admin-settings-icon-btn {
    color: #f0ad4e;
    padding: 5px 10px;
  }

  .admin-settings-icon-btn:hover {
    color: #ffbe5c;
  }

  /* 일반 설정 버튼 - 우하단, 회색 */
  .settings-icon-btn {
    color: #adb5bd;
    padding: 5px 10px;
  }

  .settings-icon-btn:hover {
    color: #fff;
  }

  /* 조회/고급검색 버튼 (작은 크기) */
  .btn-sm-custom {
    font-size: 13px;
    padding: 6px 12px;
  }

  /* 달력 섹션 (스크롤바 없이) */
  .sidebar-calendar-section {
    margin: 5px;
    border-radius: 5px;
    background-color: #383c4a;
    padding: 5px;
  }

  /* 날짜 범위 단축 버튼 스타일 */
  .date-range-buttons {
    display: flex;
    margin: 5px;
    gap: 4px;
  }
  .date-range-buttons .btn {
    flex: 1;
  }

  /* 인라인 달력 스타일 - 밝은 톤 */
  .sidebar-calendar-section ::v-deep .flatpickr-calendar {
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    box-shadow: none;
    width: 100%;
    max-width: 100%;
    font-size: 13px;
  }

  .sidebar-calendar-section ::v-deep .flatpickr-calendar.inline {
    top: 0;
    position: relative;
  }

  .sidebar-calendar-section ::v-deep .flatpickr-innerContainer {
    max-width: 100%;
  }

  .sidebar-calendar-section ::v-deep .flatpickr-rContainer {
    max-width: 100%;
  }

  .sidebar-calendar-section ::v-deep .flatpickr-days {
    width: 100%;
  }

  .sidebar-calendar-section ::v-deep .dayContainer {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }

  .sidebar-calendar-section ::v-deep .flatpickr-months {
    background: #e9ecef;
    border-radius: 5px 5px 0 0;
  }

  .sidebar-calendar-section ::v-deep .flatpickr-month,
  .sidebar-calendar-section ::v-deep .flatpickr-current-month,
  .sidebar-calendar-section ::v-deep .flatpickr-monthDropdown-months {
    background: #e9ecef;
    color: #333;
  }

  .sidebar-calendar-section ::v-deep .flatpickr-current-month input.cur-year {
    color: #333;
  }

  .sidebar-calendar-section ::v-deep .flatpickr-weekdays {
    background: #e9ecef;
  }

  .sidebar-calendar-section ::v-deep span.flatpickr-weekday {
    background: #e9ecef;
    color: #666;
    font-weight: 600;
  }

  .sidebar-calendar-section ::v-deep .flatpickr-day {
    color: #333;
    border-radius: 3px;
    max-width: 100%;
    height: 32px;
    line-height: 32px;
  }

  .sidebar-calendar-section ::v-deep .flatpickr-day:hover {
    background: #dee2e6;
    border-color: #dee2e6;
  }

  .sidebar-calendar-section ::v-deep .flatpickr-day.selected,
  .sidebar-calendar-section ::v-deep .flatpickr-day.startRange,
  .sidebar-calendar-section ::v-deep .flatpickr-day.endRange {
    background: #007bff;
    border-color: #007bff;
    color: white;
  }

  .sidebar-calendar-section ::v-deep .flatpickr-day.inRange {
    background: #cce5ff;
    border-color: #cce5ff;
    box-shadow: -5px 0 0 #cce5ff, 5px 0 0 #cce5ff;
    color: #333;
  }

  .sidebar-calendar-section ::v-deep .flatpickr-day.prevMonthDay,
  .sidebar-calendar-section ::v-deep .flatpickr-day.nextMonthDay {
    color: #adb5bd;
  }

  .sidebar-calendar-section ::v-deep .flatpickr-day.today {
    border-color: #007bff;
  }

  .sidebar-calendar-section ::v-deep .numInputWrapper span {
    border: none;
  }

  .sidebar-calendar-section ::v-deep .flatpickr-prev-month,
  .sidebar-calendar-section ::v-deep .flatpickr-next-month {
    fill: #333;
  }

  .sidebar-calendar-section ::v-deep .flatpickr-prev-month:hover svg,
  .sidebar-calendar-section ::v-deep .flatpickr-next-month:hover svg {
    fill: #007bff;
  }

  /* flatpickr 입력 필드 숨김 (inline 모드) */
  .sidebar-calendar-section ::v-deep input.flatpickr-input {
    display: none;
  }

  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .loading-spinner {
    background-color: white;
    padding: 30px 50px;
    border-radius: 10px;
    text-align: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  }

  .loading-spinner i {
    color: #4b5162;
  }

  .loading-spinner p {
    margin-bottom: 0;
    color: #4b5162;
    font-weight: 500;
  }

  /* Dataset container - limit max width for better aesthetics */
  .container-fluid {
    max-width: 1400px;
  }

  /* Dataset table styles - prevent header text wrapping */
  .dataset-table {
    width: 100%;
    table-layout: auto;
  }

  .dataset-table >>> .table-header-nowrap th {
    white-space: nowrap;
    vertical-align: middle;
    padding: 0.5rem 0.75rem;
  }

  .dataset-table >>> td {
    vertical-align: middle;
    padding: 0.5rem 0.75rem;
  }
  </style>
  